import React, { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";


const API_BASE = "https://panel.haymestasarim.com/api";
const API_MENU = "https://panel.haymestasarim.com/api/public/menu";
const API_ILETISIM = "https://panel.haymestasarim.com/api/iletisim/public";
const API_ORDERS = "https://panel.haymestasarim.com/api/public/qr-orders";
const IMAGE_BASE = "/menu/images";
const QR_THEME_STYLES = {
  standard:{name:"Standart",icon:"☕",primary:"#ff8a00",dark:"#0b1d2d",bg:"#f4f6f8",card:"#ffffff",text:"#0b1d2d"},
  luxury_gold:{name:"Luxury Gold",icon:"👑",primary:"#d4af37",dark:"#111111",bg:"#f7f2e8",card:"#ffffff",text:"#111111"},
  coffee:{name:"Coffee House",icon:"☕",primary:"#8B5E3C",dark:"#2b1b12",bg:"#f5efe8",card:"#ffffff",text:"#2b1b12"},
  modern_dark:{name:"Modern Dark",icon:"🌙",primary:"#38bdf8",dark:"#020617",bg:"#0f172a",card:"#111827",text:"#ffffff"},
  nature:{name:"Nature Green",icon:"🌿",primary:"#22c55e",dark:"#14532d",bg:"#f0fdf4",card:"#ffffff",text:"#14532d"},

  pizza:{name:"Pizza Italy",icon:"🍕",primary:"#ef4444",dark:"#14532d",bg:"#fff7ed",card:"#ffffff",text:"#1f2937"},
  burger:{name:"Burger Red",icon:"🍔",primary:"#dc2626",dark:"#3b1d0f",bg:"#fff7ed",card:"#ffffff",text:"#3b1d0f"},
  steak:{name:"Steak Premium",icon:"🥩",primary:"#b91c1c",dark:"#1c0f0a",bg:"#fff1f2",card:"#ffffff",text:"#1c0f0a"},
  sushi:{name:"Sushi Black",icon:"🍣",primary:"#f43f5e",dark:"#111827",bg:"#f8fafc",card:"#ffffff",text:"#111827"},
  bakery:{name:"Bakery Cream",icon:"🥐",primary:"#d97706",dark:"#78350f",bg:"#fffbeb",card:"#ffffff",text:"#78350f"},

  icecream:{name:"Ice Cream Pink",icon:"🍦",primary:"#f472b6",dark:"#831843",bg:"#fdf2f8",card:"#ffffff",text:"#831843"},
  seafood:{name:"Seafood Blue",icon:"🐟",primary:"#0ea5e9",dark:"#0c4a6e",bg:"#ecfeff",card:"#ffffff",text:"#0c4a6e"},
  turkish:{name:"Turkish Style",icon:"TR",primary:"#dc2626",dark:"#7f1d1d",bg:"#fff1f2",card:"#ffffff",text:"#7f1d1d"},
  fastfood:{name:"Fast Food",icon:"🍟",primary:"#f97316",dark:"#7c2d12",bg:"#fff7ed",card:"#ffffff",text:"#7c2d12"},
  dessert:{name:"Dessert Sweet",icon:"🍰",primary:"#e879f9",dark:"#701a75",bg:"#fdf4ff",card:"#ffffff",text:"#701a75"},

  beauty:{name:"Beauty Rose",icon:"🌸",primary:"#ec4899",dark:"#831843",bg:"#fff1f2",card:"#ffffff",text:"#831843"},
  spa:{name:"Luxury Spa",icon:"💆",primary:"#14b8a6",dark:"#134e4a",bg:"#f0fdfa",card:"#ffffff",text:"#134e4a"},
  clinic:{name:"Clinic White",icon:"⚕️",primary:"#3b82f6",dark:"#1e3a8a",bg:"#eff6ff",card:"#ffffff",text:"#1e3a8a"},
  gold_black:{name:"Gold Black",icon:"🖤",primary:"#facc15",dark:"#0a0a0a",bg:"#111111",card:"#1f1f1f",text:"#ffffff"},
  purple:{name:"Premium Purple",icon:"💜",primary:"#8b5cf6",dark:"#2e1065",bg:"#f5f3ff",card:"#ffffff",text:"#2e1065"},

  corporate:{name:"Corporate Blue",icon:"💼",primary:"#2563eb",dark:"#0f172a",bg:"#eff6ff",card:"#ffffff",text:"#0f172a"},
  orange:{name:"MesYat Orange",icon:"🟠",primary:"#ff8a00",dark:"#0b1d2d",bg:"#fff7ed",card:"#ffffff",text:"#0b1d2d"},
  glass:{name:"Glass Effect",icon:"💎",primary:"#06b6d4",dark:"#164e63",bg:"#ecfeff",card:"#ffffff",text:"#164e63"},
  minimal:{name:"Minimal Gray",icon:"⚪",primary:"#64748b",dark:"#1f2937",bg:"#f8fafc",card:"#ffffff",text:"#1f2937"},
  business:{name:"Dark Business",icon:"🏢",primary:"#60a5fa",dark:"#020617",bg:"#0f172a",card:"#111827",text:"#ffffff"},

  neon:{name:"Neon Style",icon:"✨",primary:"#22d3ee",dark:"#111827",bg:"#0f172a",card:"#111827",text:"#ffffff"},
  cyber:{name:"Cyber",icon:"🤖",primary:"#a3e635",dark:"#1a2e05",bg:"#f7fee7",card:"#ffffff",text:"#1a2e05"},
  gradient:{name:"Gradient",icon:"🌈",primary:"#9333ea",dark:"#1e1b4b",bg:"#faf5ff",card:"#ffffff",text:"#1e1b4b"},
  instagram:{name:"Instagram Style",icon:"📸",primary:"#e1306c",dark:"#833ab4",bg:"#fff1f2",card:"#ffffff",text:"#4c1d95"},
  marble:{name:"Luxury Marble",icon:"🏛️",primary:"#94a3b8",dark:"#334155",bg:"#f8fafc",card:"#ffffff",text:"#334155"},

  ocean:{name:"Ocean",icon:"🌊",primary:"#0284c7",dark:"#075985",bg:"#e0f2fe",card:"#ffffff",text:"#075985"},
  forest:{name:"Forest",icon:"🌲",primary:"#16a34a",dark:"#14532d",bg:"#f0fdf4",card:"#ffffff",text:"#14532d"},
  vintage:{name:"Vintage",icon:"📻",primary:"#a16207",dark:"#422006",bg:"#fef3c7",card:"#ffffff",text:"#422006"},
  royal:{name:"Royal",icon:"👑",primary:"#7c3aed",dark:"#312e81",bg:"#eef2ff",card:"#ffffff",text:"#312e81"},
  wood:{name:"Wood Cafe",icon:"🪵",primary:"#92400e",dark:"#431407",bg:"#fffbeb",card:"#ffffff",text:"#431407"},

  classic:{name:"Classic",icon:"⭐",primary:"#6b7280",dark:"#111827",bg:"#f9fafb",card:"#ffffff",text:"#111827"},
  premium:{name:"Premium",icon:"💎",primary:"#7c3aed",dark:"#1e1b4b",bg:"#f5f3ff",card:"#ffffff",text:"#1e1b4b"},
  summer:{name:"Summer",icon:"☀️",primary:"#f59e0b",dark:"#7c2d12",bg:"#fff7ed",card:"#ffffff",text:"#7c2d12"},
  night:{name:"Night Mode",icon:"🌃",primary:"#818cf8",dark:"#020617",bg:"#111827",card:"#1f2937",text:"#ffffff"},
  custom:{name:"Custom Brand",icon:"🎨",primary:"#0ea5e9",dark:"#0f172a",bg:"#f0f9ff",card:"#ffffff",text:"#0f172a"}
};

/* 🌍 Tarayıcı dili */
const MENU_LANGS = ["tr", "en", "de", "ar", "fa", "ru", "sq", "es", "pt"];

function detectLang() {
  const l = navigator.language?.slice(0, 2);
  return MENU_LANGS.includes(l) ? l : "tr";
}

/* 🔁 Flutter birebir fallback */
function resolveLang(obj, field, lang) {
  return (
    obj?.[`${field}_${lang}`] ||
    obj?.[`${field}_tr`] ||
    obj?.[`${field}_en`] ||
    obj?.[`${field}_de`] ||
    obj?.[`${field}_ar`] ||
    obj?.[`${field}_fa`] ||
    obj?.[`${field}_ru`] ||
    obj?.[`${field}_sq`] ||
    obj?.[`${field}_es`] ||
    obj?.[`${field}_pt`] ||
    obj?.[field] ||
    ""
  );
}

/* slug */
function slugify(text) {
  return text
    .toLowerCase()
    .replaceAll("&", "ve")
    .replaceAll("ı", "i")
    .replaceAll("ğ", "g")
    .replaceAll("ü", "u")
    .replaceAll("ş", "s")
    .replaceAll("ö", "o")
    .replaceAll("ç", "c")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "");
}

/* kategori resmi */
function resolveCategoryImage(category, section) {
  // 1) İşletmenin panelden seçtiği özel ana kategori resmi varsa önce onu göster
  const uploadedImage =
    section?.image ||
    section?.resim_url ||
    section?.gorsel ||
    section?.category_image ||
    category?.image ||
    category?.resim_url ||
    category?.gorsel ||
    category?.category_image ||
    "";

  if (String(uploadedImage).trim() !== "") {
    return uploadedImage;
  }

  // 2) İşletme özel resim seçmediyse sistemdeki hazır/default kategori resmi gelsin
  if (section?.category_key) {
    return `${IMAGE_BASE}/${section.category_key}.jpg`;
  }

  if (category?.category_key) {
    return `${IMAGE_BASE}/${category.category_key}.jpg`;
  }

  // 3) Hiçbiri yoksa genel default
  return `${IMAGE_BASE}/default.jpg`;
}

/* 🔗 Mini sosyal ikon */
/* mini sosyal icon (YENİ – GERÇEK SVG) */
function MiniIcon({ href, type }) {
  const icons = {
    instagram: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5a5 5 0 100 10 5 5 0 000-10zm6.5-.9a1.1 1.1 0 110 2.2 1.1 1.1 0 010-2.2z"/>
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M23 12s0-4-1-6a3 3 0 00-2-2c-2-.5-8-.5-8-.5s-6 0-8 .5a3 3 0 00-2 2c-1 2-1 6-1 6s0 4 1 6a3 3 0 002 2c2 .5 8 .5 8 .5s6 0 8-.5a3 3 0 002-2c1-2 1-6 1-6zM10 15V9l5 3-5 3z"/>
      </svg>
    ),
    facebook: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M22 12a10 10 0 10-11.5 9.9v-7H8v-3h2.5V9.5c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.7-1.6 1.5V12H16l-.4 3h-2.3v7A10 10 0 0022 12z"/>
      </svg>
    ),
    web: (
      <svg viewBox="0 0 24 24" width="18" height="18" fill="#0b1d2d">
        <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm7.9 9h-3a15 15 0 00-1.5-5A8 8 0 0119.9 11zM12 4c.9 1.2 1.7 3 2.1 5H9.9c.4-2 1.2-3.8 2.1-5zM4.1 13h3a15 15 0 001.5 5A8 8 0 014.1 13zm3-2h-3a8 8 0 014.4-5 15 15 0 00-1.4 5zm4.9 9c-.9-1.2-1.7-3-2.1-5h4.2c-.4 2-1.2 3.8-2.1 5zm3.5-2a15 15 0 001.5-5h3a8 8 0 01-4.5 5z"/>
      </svg>
    )
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        width: 38,
        height: 38,
        borderRadius: "50%",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 6px 14px rgba(0,0,0,.25)"
      }}
    >
      {icons[type]}
    </a>
  );
}



/* metinler */

/* metinler */
const TEXT = {

welcome: {
tr:"Hoş geldiniz",
en:"Welcome",
de:"Willkommen",
ar:"مرحبا بكم",
fa:"خوش آمدید",
ru:"Добро пожаловать",
sq:"Mirë se vini",
es:"Bienvenido",
pt:"Bem-vindo"
},

search:{
tr:"Lezzet arayın…",
en:"Search for flavors…",
de:"Nach Geschmack suchen…",
ar:"ابحث عن النكهات…",
fa:"جستجوی طعم‌ها…",
ru:"Поиск блюд…",
sq:"Kërko shije…",
es:"Buscar sabores…",
pt:"Pesquisar sabores…"
},

trends:{
tr:"Trend Ürünlerimiz",
en:"Featured Items",
de:"Trendprodukte",
ar:"المنتجات المميزة",
fa:"محصولات ویژه",
ru:"Популярные товары",
sq:"Produktet e veçuara",
es:"Productos destacados",
pt:"Produtos em destaque"
},

showcase:{
tr:"Menü Vitrini",
en:"Menu Showcase",
de:"Menü-Schaufenster",
ar:"واجهة القائمة",
fa:"ویترین منو",
ru:"Витрина меню",
sq:"Vitrina e menusë",
es:"Escaparate del menú",
pt:"Vitrine do menu"
},

backToShowcase:{
tr:"Vitrine Dön",
en:"Back to Showcase",
de:"Zurück zur Übersicht",
ar:"العودة إلى الواجهة",
fa:"بازگشت به ویترین",
ru:"Назад к витрине",
sq:"Kthehu te vitrina",
es:"Volver al escaparate",
pt:"Voltar à vitrine"
},

showcaseItems:{
tr:"ürün",
en:"items",
de:"Produkte",
ar:"منتج",
fa:"محصول",
ru:"позиций",
sq:"produkte",
es:"productos",
pt:"produtos"
},

showcaseEmpty:{
tr:"Bu bölümde henüz ürün bulunmuyor.",
en:"There are no items in this section yet.",
de:"In diesem Bereich gibt es noch keine Produkte.",
ar:"لا توجد منتجات في هذا القسم حتى الآن.",
fa:"هنوز محصولی در این بخش وجود ندارد.",
ru:"В этом разделе пока нет товаров.",
sq:"Në këtë seksion nuk ka ende produkte.",
es:"Aún no hay productos en esta sección.",
pt:"Ainda não há produtos nesta secção."
},

categories:{

tr:"Kategoriler",
en:"Categories",
de:"Kategorien",
ar:"الفئات",
fa:"دسته‌بندی‌ها",
ru:"Категории",
sq:"Kategoritë",
es:"Categorías",
pt:"Categorias"
},

categoriesSub:{
tr:"Tüm lezzetlerimizi keşfedin",
en:"Explore all our selections",
de:"Entdecken Sie unsere Auswahl",
ar:"اكتشف جميع اختياراتنا",
fa:"همه انتخاب‌های ما را کشف کنید",
ru:"Откройте для себя наш ассортимент",
sq:"Zbuloni zgjedhjet tona",
es:"Descubra nuestra selección",
pt:"Descubra nossa seleção"
},

thanks:{
tr:"Bizi tercih ettiğiniz için teşekkür ederiz",
en:"Thank you for choosing us",
de:"Vielen Dank, dass Sie sich für uns entschieden haben",
ar:"شكرا لاختياركم لنا",
fa:"از انتخاب شما سپاسگزاریم",
ru:"Спасибо, что выбрали нас",
sq:"Faleminderit që na zgjodhët",
es:"Gracias por elegirnos",
pt:"Obrigado por nos escolher"
},

  // ✅ EKLENDI: Sipariş metinleri
  // ✅ PROFESYONEL ÇOK DİLLİ SİPARİŞ / GARSON METİNLERİ
   addToCart: {
    tr: "Sepete Ekle",
    en: "Add to Cart",
    de: "In den Warenkorb",
    ar: "أضف إلى السلة",
    fa: "افزودن به سبد",
    ru: "В корзину",
    sq: "Shto në shportë",
    es: "Añadir al carrito",
    pt: "Adicionar ao carrinho"
  },

  cartAddedTitle: {
    tr: "Sepete eklendi",
    en: "Added to cart",
    de: "Zum Warenkorb hinzugefügt",
    ar: "تمت الإضافة إلى السلة",
    fa: "به سبد خرید اضافه شد",
    ru: "Добавлено в корзину",
    sq: "U shtua në shportë",
    es: "Añadido al carrito",
    pt: "Adicionado ao carrinho"
  },

  cartAddedText: {
    tr: "Ürün başarıyla sepetinize eklendi.",
    en: "The item has been added to your cart.",
    de: "Das Produkt wurde Ihrem Warenkorb hinzugefügt.",
    ar: "تمت إضافة المنتج إلى سلتك بنجاح.",
    fa: "محصول با موفقیت به سبد خرید شما اضافه شد.",
    ru: "Товар успешно добавлен в корзину.",
    sq: "Produkti u shtua me sukses në shportë.",
    es: "El producto se agregó correctamente al carrito.",
    pt: "O produto foi adicionado ao carrinho com sucesso."
  },

  cart: {
    tr: "Sepetim",
    en: "My Cart",
    de: "Mein Warenkorb",
    ar: "سلتي",
    fa: "سبد خرید من",
    ru: "Моя корзина",
    sq: "Shporta ime",
    es: "Mi carrito",
    pt: "Meu carrinho"
  },

  total: {
    tr: "Toplam",
    en: "Total",
    de: "Gesamt",
    ar: "المجموع",
    fa: "مجموع",
    ru: "Итого",
    sq: "Totali",
    es: "Total",
    pt: "Total"
  },

  orderNow: {
    tr: "Sipariş Ver",
    en: "Place Order",
    de: "Bestellen",
    ar: "إرسال الطلب",
    fa: "ثبت سفارش",
    ru: "Оформить заказ",
    sq: "Bëj porosinë",
    es: "Realizar pedido",
    pt: "Fazer pedido"
  },

  customerName: {
    tr: "Adınız",
    en: "Your Name",
    de: "Ihr Name",
    ar: "اسمك",
    fa: "نام شما",
    ru: "Ваше имя",
    sq: "Emri juaj",
    es: "Su nombre",
    pt: "Seu nome"
  },

  tableNo: {
    tr: "Masa No (opsiyonel)",
    en: "Table No (optional)",
    de: "Tischnummer (optional)",
    ar: "رقم الطاولة (اختياري)",
    fa: "شماره میز (اختیاری)",
    ru: "Номер стола (необязательно)",
    sq: "Numri i tavolinës (opsional)",
    es: "Mesa Nº (opcional)",
    pt: "Nº da mesa (opcional)"
  },

  orderNote: {
    tr: "Sipariş Notu (isteğe bağlı)",
    en: "Order Note (optional)",
    de: "Bestellnotiz (optional)",
    ar: "ملاحظة الطلب (اختياري)",
    fa: "یادداشت سفارش (اختیاری)",
    ru: "Примечание к заказу",
    sq: "Shënim porosie",
    es: "Nota del pedido",
    pt: "Observação do pedido"
  },

  emptyCart: {
    tr: "Sepetiniz boş",
    en: "Your cart is empty",
    de: "Ihr Warenkorb ist leer",
    ar: "سلتك فارغة",
    fa: "سبد خرید شما خالی است",
    ru: "Ваша корзина пуста",
    sq: "Shporta është bosh",
    es: "Tu carrito está vacío",
    pt: "Seu carrinho está vazio"
  },

  waiterTitle: {
    tr: "Garson Çağır",
    en: "Call Waiter",
    de: "Kellner rufen",
    ar: "استدعاء النادل",
    fa: "فراخوانی گارسون",
    ru: "Позвать официанта",
    sq: "Thirr kamerierin",
    es: "Llamar al camarero",
    pt: "Chamar garçom"
  },

  cancel: {
    tr: "Vazgeç",
    en: "Cancel",
    de: "Abbrechen",
    ar: "إلغاء",
    fa: "لغو",
    ru: "Отмена",
    sq: "Anulo",
    es: "Cancelar",
    pt: "Cancelar"
  },

  call: {
    tr: "Çağır",
    en: "Call",
    de: "Rufen",
    ar: "استدعاء",
    fa: "فراخوان",
    ru: "Позвать",
    sq: "Thirr",
    es: "Llamar",
    pt: "Chamar"
  },

  missingInfoTitle: {
    tr: "Bilgi eksik",
    en: "Missing information",
    de: "Angaben fehlen",
    ar: "المعلومات ناقصة",
    fa: "اطلاعات ناقص است",
    ru: "Недостаточно данных",
    sq: "Mungon informacioni",
    es: "Falta información",
    pt: "Faltam informações"
  },

  missingWaiterText: {
    tr: "Lütfen masa numarası veya adınızı yazın.",
    en: "Please enter your table number or name.",
    de: "Bitte geben Sie Ihre Tischnummer oder Ihren Namen ein.",
    ar: "يرجى إدخال رقم الطاولة أو اسمك.",
    fa: "لطفاً شماره میز یا نام خود را وارد کنید.",
    ru: "Введите номер стола или ваше имя.",
    sq: "Ju lutemi shkruani numrin e tavolinës ose emrin tuaj.",
    es: "Por favor, escriba el número de mesa o su nombre.",
    pt: "Digite o número da mesa ou seu nome."
  },

  waiterSuccessTitle: {
    tr: "Garson yönlendirildi",
    en: "Waiter is on the way",
    de: "Kellner wurde informiert",
    ar: "النادل في الطريق",
    fa: "گارسون در راه است",
    ru: "Официант уже идет",
    sq: "Kamerieri po vjen",
    es: "El camarero está en camino",
    pt: "O garçom está a caminho"
  },

  waiterSuccessText: {
    tr: "Ekibimiz birazdan masanıza yardımcı olacak.",
    en: "Our team will assist your table shortly.",
    de: "Unser Team ist gleich an Ihrem Tisch.",
    ar: "سيصل فريقنا إلى طاولتك بعد قليل.",
    fa: "تیم ما به‌زودی به میز شما کمک خواهد کرد.",
    ru: "Наша команда скоро подойдет к вашему столу.",
    sq: "Ekipi ynë do t’ju ndihmojë së shpejti.",
    es: "Nuestro equipo le atenderá en breve.",
    pt: "Nossa equipe irá atendê-lo em breve."
  },

  orderNameMissingText: {
    tr: "Sipariş için lütfen adınızı yazın.",
    en: "Please enter your name for the order.",
    de: "Bitte geben Sie Ihren Namen für die Bestellung ein.",
    ar: "يرجى كتابة اسمك لإتمام الطلب.",
    fa: "برای ثبت سفارش لطفاً نام خود را وارد کنید.",
    ru: "Введите ваше имя для заказа.",
    sq: "Ju lutemi shkruani emrin për porosinë.",
    es: "Escriba su nombre para el pedido.",
    pt: "Digite seu nome para o pedido."
  },

  emptyCartText: {
    tr: "Sipariş vermek için önce sepetinize ürün ekleyin.",
    en: "Please add items to your cart before ordering.",
    de: "Bitte legen Sie zuerst Produkte in den Warenkorb.",
    ar: "يرجى إضافة منتجات إلى السلة أولاً.",
    fa: "ابتدا محصولی به سبد خرید اضافه کنید.",
    ru: "Сначала добавьте товары в корзину.",
    sq: "Së pari shtoni produkte në shportë.",
    es: "Primero agregue productos al carrito.",
    pt: "Adicione produtos ao carrinho primeiro."
  },

  orderSuccessTitle: {
    tr: "Siparişiniz alındı",
    en: "Order received",
    de: "Bestellung eingegangen",
    ar: "تم استلام طلبك",
    fa: "سفارش شما ثبت شد",
    ru: "Заказ принят",
    sq: "Porosia u pranua",
    es: "Pedido recibido",
    pt: "Pedido recebido"
  },

  orderSuccessText: {
    tr: "Teşekkür ederiz. Siparişiniz hazırlanıyor.",
    en: "Thank you. Your order is being prepared.",
    de: "Vielen Dank. Ihre Bestellung wird vorbereitet.",
    ar: "شكراً لك. يتم تحضير طلبك الآن.",
    fa: "متشکریم. سفارش شما در حال آماده‌سازی است.",
    ru: "Спасибо. Ваш заказ готовится.",
    sq: "Faleminderit. Porosia juaj po përgatitet.",
    es: "Gracias. Su pedido se está preparando.",
    pt: "Obrigado. Seu pedido está sendo preparado."
  },

  processErrorTitle: {
    tr: "İşlem tamamlanamadı",
    en: "Action could not be completed",
    de: "Vorgang konnte nicht abgeschlossen werden",
    ar: "تعذر إكمال العملية",
    fa: "عملیات کامل نشد",
    ru: "Не удалось выполнить действие",
    sq: "Veprimi nuk u përfundua",
    es: "No se pudo completar la acción",
    pt: "Não foi possível concluir a ação"
  },

  processErrorText: {
    tr: "Lütfen birkaç saniye sonra tekrar deneyin.",
    en: "Please try again in a few seconds.",
    de: "Bitte versuchen Sie es in einigen Sekunden erneut.",
    ar: "يرجى المحاولة مرة أخرى بعد ثوانٍ قليلة.",
    fa: "لطفاً چند ثانیه بعد دوباره تلاش کنید.",
    ru: "Попробуйте снова через несколько секунд.",
    sq: "Ju lutemi provoni përsëri pas pak sekondash.",
    es: "Inténtelo de nuevo en unos segundos.",
    pt: "Tente novamente em alguns segundos."
  },

  connectionErrorTitle: {
    tr: "Bağlantı sorunu",
    en: "Connection issue",
    de: "Verbindungsproblem",
    ar: "مشكلة في الاتصال",
    fa: "مشکل اتصال",
    ru: "Проблема соединения",
    sq: "Problem lidhjeje",
    es: "Problema de conexión",
    pt: "Problema de conexão"
  },

  connectionErrorText: {
    tr: "İstek gönderilemedi. Lütfen tekrar deneyin.",
    en: "Request could not be sent. Please try again.",
    de: "Anfrage konnte nicht gesendet werden. Bitte erneut versuchen.",
    ar: "تعذر إرسال الطلب. يرجى المحاولة مرة أخرى.",
    fa: "درخواست ارسال نشد. لطفاً دوباره تلاش کنید.",
    ru: "Запрос не отправлен. Попробуйте снова.",
    sq: "Kërkesa nuk u dërgua. Provoni përsëri.",
    es: "No se pudo enviar la solicitud. Inténtelo de nuevo.",
    pt: "Não foi possível enviar. Tente novamente."
  },

  menuHome: {
    tr: "Menü",
    en: "Menu",
    de: "Menü",
    ar: "القائمة",
    fa: "منو",
    ru: "Меню",
    sq: "Menu",
    es: "Menú",
    pt: "Menu"
  },

  billPayTitle: {
    tr: "Hesabımı Gör / Öde",
    en: "View / Pay Bill",
    de: "Rechnung ansehen / bezahlen",
    ar: "عرض / دفع الحساب",
    fa: "مشاهده / پرداخت حساب",
    ru: "Посмотреть / оплатить счет",
    sq: "Shiko / paguaj faturën",
    es: "Ver / pagar cuenta",
    pt: "Ver / pagar conta"
  },

  billPayShort: {
    tr: "Hesap",
    en: "Bill",
    de: "Rechnung",
    ar: "الحساب",
    fa: "حساب",
    ru: "Счёт",
    sq: "Fatura",
    es: "Cuenta",
    pt: "Conta"
  },

  billPaySub: {
    tr: "Masa hesabınızı görüntüleyin, bölüştürün veya ödeme talebi oluşturun.",
    en: "View your table bill, split it or create a payment request.",
    de: "Sehen Sie Ihre Tischrechnung, teilen Sie sie oder erstellen Sie eine Zahlungsanfrage.",
    ar: "اعرض حساب الطاولة أو قسّمه أو أنشئ طلب دفع.",
    fa: "حساب میز خود را ببینید، تقسیم کنید یا درخواست پرداخت بسازید.",
    ru: "Просмотрите счёт стола, разделите его или создайте запрос на оплату.",
    sq: "Shikoni faturën e tavolinës, ndajeni ose krijoni kërkesë pagese.",
    es: "Vea la cuenta de la mesa, divídala o cree una solicitud de pago.",
    pt: "Veja a conta da mesa, divida-a ou crie um pedido de pagamento."
  },

  billFullPay: {
    tr: "Hesabın Tamamını Öde",
    en: "Pay Full Bill",
    de: "Gesamte Rechnung bezahlen",
    ar: "ادفع الحساب كاملاً",
    fa: "پرداخت کل حساب",
    ru: "Оплатить весь счёт",
    sq: "Paguaj të gjithë faturën",
    es: "Pagar toda la cuenta",
    pt: "Pagar conta total"
  },

  billByItems: {
    tr: "Ürün Seçerek Öde",
    en: "Pay by Selecting Items",
    de: "Nach Produkten bezahlen",
    ar: "ادفع باختيار المنتجات",
    fa: "پرداخت با انتخاب محصولات",
    ru: "Оплатить выбранные позиции",
    sq: "Paguaj duke zgjedhur produktet",
    es: "Pagar seleccionando productos",
    pt: "Pagar selecionando itens"
  },

  billByAmount: {
    tr: "Tutar Girerek Öde",
    en: "Pay Custom Amount",
    de: "Eigenen Betrag bezahlen",
    ar: "ادفع مبلغاً محدداً",
    fa: "پرداخت مبلغ دلخواه",
    ru: "Оплатить свою сумму",
    sq: "Paguaj shumë të personalizuar",
    es: "Pagar importe personalizado",
    pt: "Pagar valor personalizado"
  },

  billByPeople: {
    tr: "Kişi Sayısına Böl",
    en: "Split by People",
    de: "Nach Personen teilen",
    ar: "قسّم حسب عدد الأشخاص",
    fa: "تقسیم بر تعداد افراد",
    ru: "Разделить по людям",
    sq: "Ndaj sipas personave",
    es: "Dividir por personas",
    pt: "Dividir por pessoas"
  },

  billByItemsDesc: {
    tr: "Adil ödeme için kendi ürünlerinizi seçin.",
    en: "Select your own items for a fair payment.",
    de: "Wählen Sie Ihre eigenen Produkte für eine faire Zahlung.",
    ar: "اختر منتجاتك الخاصة لدفع عادل.",
    fa: "برای پرداخت منصفانه محصولات خود را انتخاب کنید.",
    ru: "Выберите свои позиции для справедливой оплаты.",
    sq: "Zgjidhni produktet tuaja për pagesë të drejtë.",
    es: "Seleccione sus productos para un pago justo.",
    pt: "Selecione os seus itens para um pagamento justo."
  },

  billByAmountDesc: {
    tr: "İstediğiniz tutarı girerek ödeme talebi oluşturun.",
    en: "Enter the amount you want and create a payment request.",
    de: "Geben Sie Ihren gewünschten Betrag ein und erstellen Sie eine Zahlungsanfrage.",
    ar: "أدخل المبلغ الذي تريده وأنشئ طلب دفع.",
    fa: "مبلغ موردنظر را وارد کرده و درخواست پرداخت بسازید.",
    ru: "Введите нужную сумму и создайте запрос на оплату.",
    sq: "Shkruani shumën që dëshironi dhe krijoni kërkesë pagese.",
    es: "Introduzca el importe deseado y cree una solicitud de pago.",
    pt: "Introduza o valor desejado e crie um pedido de pagamento."
  },

  billByPeopleDesc: {
    tr: "Hesabı kişi sayısına göre otomatik bölün.",
    en: "Split the bill automatically by number of people.",
    de: "Teilen Sie die Rechnung automatisch nach Personenanzahl.",
    ar: "قسّم الحساب تلقائياً حسب عدد الأشخاص.",
    fa: "حساب را به‌صورت خودکار بر اساس تعداد افراد تقسیم کنید.",
    ru: "Разделите счёт автоматически по количеству людей.",
    sq: "Ndajeni faturën automatikisht sipas numrit të personave.",
    es: "Divida la cuenta automáticamente por número de personas.",
    pt: "Divida a conta automaticamente pelo número de pessoas."
  },

  billTip: {
    tr: "Bahşiş Ekle",
    en: "Add Tip",
    de: "Trinkgeld hinzufügen",
    ar: "إضافة بقشيش",
    fa: "افزودن انعام",
    ru: "Добавить чаевые",
    sq: "Shto bakshish",
    es: "Añadir propina",
    pt: "Adicionar gorjeta"
  },

  billReview: {
    tr: "Ödeme Sonrası Puanlama",
    en: "Post-payment Rating",
    de: "Bewertung nach Zahlung",
    ar: "التقييم بعد الدفع",
    fa: "امتیازدهی پس از پرداخت",
    ru: "Оценка после оплаты",
    sq: "Vlerësim pas pagesës",
    es: "Valoración después del pago",
    pt: "Avaliação após pagamento"
  },

  billComingTitle: {
    tr: "Akıllı hesap sistemi hazırlanıyor",
    en: "Smart bill system is being prepared",
    de: "Intelligentes Rechnungssystem wird vorbereitet",
    ar: "يتم تجهيز نظام الحساب الذكي",
    fa: "سیستم حساب هوشمند در حال آماده‌سازی است",
    ru: "Система умного счёта готовится",
    sq: "Sistemi inteligjent i faturës po përgatitet",
    es: "El sistema de cuenta inteligente se está preparando",
    pt: "O sistema de conta inteligente está a ser preparado"
  },

  billComingText: {
    tr: "İşletme panelinde masa hesabı açıldığında ürün bazlı ödeme, tutar girerek ödeme ve kişi sayısına bölme burada canlı çalışacak.",
    en: "When the table bill is opened in the business panel, item-based payment, custom amount payment and split by people will work here live.",
    de: "Wenn die Tischrechnung im Betreiberpanel geöffnet wird, funktionieren Produktzahlung, individueller Betrag und Aufteilung nach Personen hier live.",
    ar: "عند فتح حساب الطاولة من لوحة المنشأة ستعمل هنا خيارات الدفع حسب المنتج أو المبلغ أو عدد الأشخاص مباشرة.",
    fa: "وقتی حساب میز در پنل کسب‌وکار باز شود، پرداخت بر اساس محصول، مبلغ دلخواه و تقسیم بین افراد اینجا فعال خواهد شد.",
    ru: "Когда счёт стола будет открыт в панели, здесь будут работать оплата по позициям, своя сумма и разделение по людям.",
    sq: "Kur fatura e tavolinës hapet në panel, pagesa sipas produkteve, shuma e personalizuar dhe ndarja sipas personave do të punojnë këtu live.",
    es: "Cuando la cuenta de la mesa se abra en el panel, el pago por productos, importe personalizado y división por personas funcionarán aquí en vivo.",
    pt: "Quando a conta da mesa for aberta no painel, pagamento por itens, valor personalizado e divisão por pessoas funcionarão aqui ao vivo."
  },

  tableBill: {
    tr: "Masa Hesabı",
    en: "Table Bill",
    de: "Tischrechnung",
    ar: "حساب الطاولة",
    fa: "حساب میز",
    ru: "Счёт стола",
    sq: "Fatura e tavolinës",
    es: "Cuenta de mesa",
    pt: "Conta da mesa"
  }
};

function t(key, lang) {
  return TEXT[key]?.[lang] || TEXT[key]?.tr || "";
}

/* =========================================================
   ✅ PUBLIC MENÜ - MEVZUATA UYUMLU ÜRÜN BİLGİLERİ
   Kalori, içerik, porsiyon, alerjen ve tahmini kalori notu
========================================================= */

const PUBLIC_COMPLIANCE_TEXT = {
  calories: {
    tr: "Kalori",
    en: "Calories",
    de: "Kalorien",
    ar: "السعرات",
    fa: "کالری",
    ru: "Калории",
    sq: "Kalori",
    es: "Calorías",
    pt: "Calorias",
  },
  estimated: {
    tr: "Tahmini",
    en: "Estimated",
    de: "Geschätzt",
    ar: "تقديري",
    fa: "تخمینی",
    ru: "Оценка",
    sq: "E përafërt",
    es: "Estimado",
    pt: "Estimado",
  },
  portion: {
    tr: "Porsiyon",
    en: "Portion",
    de: "Portion",
    ar: "الحصة",
    fa: "پرس",
    ru: "Порция",
    sq: "Porcioni",
    es: "Porción",
    pt: "Porção",
  },
  ingredients: {
    tr: "İçindekiler",
    en: "Ingredients",
    de: "Zutaten",
    ar: "المكونات",
    fa: "مواد تشکیل‌دهنده",
    ru: "Состав",
    sq: "Përbërësit",
    es: "Ingredientes",
    pt: "Ingredientes",
  },
  allergens: {
    tr: "Alerjenler",
    en: "Allergens",
    de: "Allergene",
    ar: "مسببات الحساسية",
    fa: "آلرژن‌ها",
    ru: "Аллергены",
    sq: "Alergjenët",
    es: "Alérgenos",
    pt: "Alergénios",
  },
  warning: {
    tr: "Uyarı",
    en: "Note",
    de: "Hinweis",
    ar: "تنبيه",
    fa: "هشدار",
    ru: "Примечание",
    sq: "Shënim",
    es: "Aviso",
    pt: "Aviso",
  },
  noOfficialAdvice: {
    tr: "Bilgiler işletme tarafından kontrol edilmelidir.",
    en: "Information should be verified by the business.",
    de: "Die Angaben sollten vom Betrieb geprüft werden.",
    ar: "يجب التحقق من المعلومات من قبل المنشأة.",
    fa: "اطلاعات باید توسط کسب‌وکار بررسی شود.",
    ru: "Информация должна быть проверена заведением.",
    sq: "Informacioni duhet të kontrollohet nga biznesi.",
    es: "La información debe ser verificada por el negocio.",
    pt: "As informações devem ser verificadas pelo estabelecimento.",
  },
};

const PUBLIC_ALLERGEN_LABELS = {
  gluten: {
    tr: "Gluten",
    en: "Gluten",
    de: "Gluten",
  },
  crustaceans: {
    tr: "Kabuklular",
    en: "Crustaceans",
    de: "Krebstiere",
  },
  egg: {
    tr: "Yumurta",
    en: "Egg",
    de: "Ei",
  },
  fish: {
    tr: "Balık",
    en: "Fish",
    de: "Fisch",
  },
  peanut: {
    tr: "Yer fıstığı",
    en: "Peanuts",
    de: "Erdnüsse",
  },
  soy: {
    tr: "Soya",
    en: "Soy",
    de: "Soja",
  },
  milk: {
    tr: "Süt / Laktoz",
    en: "Milk / Lactose",
    de: "Milch / Laktose",
  },
  nuts: {
    tr: "Sert kabuklu yemişler",
    en: "Nuts",
    de: "Schalenfrüchte",
  },
  celery: {
    tr: "Kereviz",
    en: "Celery",
    de: "Sellerie",
  },
  mustard: {
    tr: "Hardal",
    en: "Mustard",
    de: "Senf",
  },
  sesame: {
    tr: "Susam",
    en: "Sesame",
    de: "Sesam",
  },
  sulphites: {
    tr: "Sülfit",
    en: "Sulphites",
    de: "Sulfite",
  },
  lupin: {
    tr: "Acı bakla",
    en: "Lupin",
    de: "Lupine",
  },
  molluscs: {
    tr: "Yumuşakçalar",
    en: "Molluscs",
    de: "Weichtiere",
  },
};

const PUBLIC_DIETARY_LABELS = {
  vegan: {
    tr: "Vegan",
    en: "Vegan",
    de: "Vegan",
  },
  vegetarian: {
    tr: "Vejetaryen",
    en: "Vegetarian",
    de: "Vegetarisch",
  },
  gluten_free: {
    tr: "Glutensiz",
    en: "Gluten-free",
    de: "Glutenfrei",
  },
  lactose_free: {
    tr: "Laktozsuz",
    en: "Lactose-free",
    de: "Laktosefrei",
  },
  contains_alcohol: {
    tr: "Alkol içerir",
    en: "Contains alcohol",
    de: "Enthält Alkohol",
  },
  no_pork: {
    tr: "Domuz türevi içermez",
    en: "No pork-derived ingredients",
    de: "Keine Schweinebestandteile",
  },
};

function ct(key, lang) {
  return (
    PUBLIC_COMPLIANCE_TEXT?.[key]?.[lang] ||
    PUBLIC_COMPLIANCE_TEXT?.[key]?.tr ||
    key
  );
}

function safePublicJsonParse(value, fallback) {
  if (value && typeof value === "object") return value;

  try {
    return JSON.parse(value || JSON.stringify(fallback));
  } catch {
    return fallback;
  }
}

function publicLangValue(obj, lang) {
  return (
    obj?.[lang] ||
    obj?.tr ||
    obj?.en ||
    obj?.de ||
    obj?.ar ||
    obj?.fa ||
    obj?.ru ||
    obj?.sq ||
    obj?.es ||
    obj?.pt ||
    ""
  );
}

function normalizePublicArray(value) {
  const list = Array.isArray(value)
    ? value
    : safePublicJsonParse(value, []);

  if (!Array.isArray(list)) return [];

  return list.map((x) => String(x || "").trim()).filter(Boolean);
}

function normalizePublicComplianceInfo(value) {
  const raw = safePublicJsonParse(value, {});

  return {
    ingredients:
      raw.ingredients && typeof raw.ingredients === "object"
        ? raw.ingredients
        : {},
    portion:
      raw.portion && typeof raw.portion === "object"
        ? raw.portion
        : {},
    warning:
      raw.warning && typeof raw.warning === "object"
        ? raw.warning
        : {},
    calories:
      raw.calories !== undefined && raw.calories !== null
        ? String(raw.calories).trim()
        : "",
    calories_estimated: raw.calories_estimated === true,
    calorie_note:
      raw.calorie_note && typeof raw.calorie_note === "object"
        ? raw.calorie_note
        : {},
    tags: Array.isArray(raw.tags)
      ? raw.tags.map((x) => String(x || "").trim()).filter(Boolean)
      : [],
  };
}

function getPublicAllergenLabels(allergens, lang) {
  return normalizePublicArray(allergens).map((key) => {
    return (
      PUBLIC_ALLERGEN_LABELS?.[key]?.[lang] ||
      PUBLIC_ALLERGEN_LABELS?.[key]?.tr ||
      key
    );
  });
}

function getPublicDietaryLabels(tags, lang) {
  return normalizePublicArray(tags).map((key) => {
    return (
      PUBLIC_DIETARY_LABELS?.[key]?.[lang] ||
      PUBLIC_DIETARY_LABELS?.[key]?.tr ||
      key
    );
  });
}

function hasPublicComplianceInfo(item) {
  const c = normalizePublicComplianceInfo(item?.compliance_info);
  const allergens = getPublicAllergenLabels(item?.allergens, "tr");
  const ingredients = publicLangValue(c.ingredients, "tr");
  const portion = publicLangValue(c.portion, "tr");
  const warning = publicLangValue(c.warning, "tr");

  return Boolean(
    c.calories ||
      ingredients ||
      portion ||
      warning ||
      allergens.length ||
      c.tags.length
  );
}



function PublicComplianceBox({ item, lang, themeStyle, compact = false }) {
  if (!hasPublicComplianceInfo(item)) return null;

  const c = normalizePublicComplianceInfo(item?.compliance_info);
  const calories = c.calories;
  const ingredients = publicLangValue(c.ingredients, lang);
  const portion = publicLangValue(c.portion, lang);
  const warning = publicLangValue(c.warning, lang);
  const allergens = getPublicAllergenLabels(item?.allergens, lang);
  const dietaryTags = getPublicDietaryLabels(c.tags, lang);

  if (compact) {
    const allergyList = [...allergens, ...dietaryTags].slice(0, 3);

    return (
      <div onClick={(e) => e.stopPropagation()} style={{ marginTop: 10, display: "grid", gap: 6 }}>
        {(calories || portion) && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
            {calories && (
              <span style={{ fontSize: 10, fontWeight: 900, color: themeStyle.primary, background: "rgba(255,138,0,.10)", border: "1px solid rgba(255,138,0,.22)", borderRadius: 999, padding: "3px 7px", lineHeight: "13px" }}>
                {calories} kcal
              </span>
            )}

            {portion && (
              <span style={{ fontSize: 10, fontWeight: 850, color: "#475569", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 999, padding: "3px 7px", lineHeight: "13px" }}>
                {portion}
              </span>
            )}
          </div>
        )}

        {allergyList.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
            {allergyList.map((label, index) => (
              <span key={`${label}-${index}`} style={{ fontSize: 9.5, fontWeight: 800, color: "#64748b", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 999, padding: "3px 7px", lineHeight: "12px" }}>
                {label}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <div onClick={(e) => e.stopPropagation()} style={{ marginTop: 12 }}>
      {(calories || portion) && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 7, marginBottom: 10 }}>
          {calories && (
            <span style={{ fontSize: 11, fontWeight: 900, color: themeStyle.primary, background: "rgba(255,138,0,.10)", border: "1px solid rgba(255,138,0,.20)", borderRadius: 999, padding: "5px 9px" }}>
              {calories} kcal
            </span>
          )}
          {portion && (
            <span style={{ fontSize: 11, fontWeight: 850, color: "#334155", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 999, padding: "5px 9px" }}>
              {portion}
            </span>
          )}
        </div>
      )}

      {ingredients && (
        <div style={{ fontSize: 12.5, color: "#475569", lineHeight: "18px", marginBottom: 9 }}>
          <strong style={{ color: "#0f172a" }}>{ct("ingredients", lang)}:</strong> {ingredients}
        </div>
      )}

      {(allergens.length > 0 || dietaryTags.length > 0) && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {[...allergens, ...dietaryTags].slice(0, 8).map((label, index) => (
            <span key={`${label}-${index}`} style={{ fontSize: 10.5, fontWeight: 800, color: "#475569", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 999, padding: "4px 8px" }}>
              {label}
            </span>
          ))}
        </div>
      )}

      {warning && (
        <div style={{ marginTop: 9, fontSize: 11.5, color: "#92400e", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 12, padding: 8, lineHeight: "16px" }}>
          {warning}
        </div>
      )}
    </div>
  );
}






// Eski ürünleri bozmaz. price_options yoksa boş array döner.
function normalizePublicPriceOptions(value) {
  let list = [];

  if (Array.isArray(value)) {
    list = value;
  } else if (typeof value === "string") {
    try {
      list = JSON.parse(value || "[]");
    } catch {
      list = [];
    }
  }

  if (!Array.isArray(list)) return [];

  return list
    .map((opt, index) => ({
      id: opt.id || `opt-${index}`,
      label: String(opt.label || opt.name || opt.title || "").trim(),
      price: Number(opt.price ?? opt.fiyat ?? 0),
      currency: opt.currency || opt.para_birimi || "TRY",
    }))
    .filter((opt) => opt.label && Number(opt.price) > 0);
}

function billNumber(value) {
  if (
    value === undefined ||
    value === null ||
    value === ""
  ) {
    return 0;
  }

  if (typeof value === "number") {
    return Number.isFinite(value)
      ? value
      : 0;
  }

  const raw = String(value)
    .trim()
    .replace(/\s/g, "");

  if (!raw) {
    return 0;
  }

  let normalized = raw;

  if (
    raw.includes(",") &&
    raw.includes(".")
  ) {
    normalized =
      raw.lastIndexOf(",") >
      raw.lastIndexOf(".")
        ? raw
            .replace(/\./g, "")
            .replace(",", ".")
        : raw.replace(/,/g, "");
  } else {
    normalized =
      raw.replace(",", ".");
  }

  const number =
    Number(normalized);

  return Number.isFinite(number)
    ? number
    : 0;
}

function moneyText(
  price,
  currency = "TRY"
) {
  const n =
    billNumber(price);

  return `${n.toLocaleString(
    "tr-TR",
    {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }
  )} ${currency || "TRY"}`;
}

function firstBillAmount(
  values = []
) {
  for (const value of values) {
    if (
      value !== undefined &&
      value !== null &&
      value !== ""
    ) {
      const amount =
        billNumber(value);

      if (amount > 0) {
        return amount;
      }
    }
  }

  return 0;
}

function normalizeTableBillData(
  rawValue
) {
  const raw =
    rawValue &&
    typeof rawValue === "object"
      ? rawValue
      : {};

  const nestedBill =
    raw.bill &&
    typeof raw.bill === "object"
      ? raw.bill
      : {};

  const summary =
    raw.summary &&
    typeof raw.summary === "object"
      ? raw.summary
      : raw.totals &&
        typeof raw.totals === "object"
      ? raw.totals
      : {};

  const source = {
    ...raw,
    ...nestedBill,
  };

  const rawItems =
    source.items ||
    source.order_items ||
    source.lines ||
    source.products ||
    source.kalemler ||
    [];

  const items =
    (
      Array.isArray(rawItems)
        ? rawItems
        : []
    ).map((item, index) => {
      const quantity =
        Math.max(
          0,

          firstBillAmount([
            item.quantity,
            item.adet,
            item.qty,
            item.miktar,
            1,
          ])
        );

      const price =
        firstBillAmount([
          item.price,
          item.unit_price,
          item.fiyat,
          item.birim_fiyat,
        ]);

      const directTotal =
        firstBillAmount([
          item.line_total,
          item.total_amount,
          item.total,
          item.tutar,
          item.toplam_tutar,
        ]);

      return {
        ...item,

        line_uid:
          item.line_uid ||
          item.uid ||
          item.id ||
          `bill-line-${index}`,

        title:
          item.title ||
          item.display_title ||
          item.name ||
          item.urun_adi ||
          item.ad ||
          "Ürün",

        quantity,

        price,

        line_total:
          directTotal > 0
            ? directTotal
            : quantity * price,

        currency:
          item.currency ||
          item.para_birimi ||
          source.currency ||
          source.para_birimi ||
          "TRY",
      };
    });

 const itemsTotal =
  items.reduce(
    (sum, item) =>
      sum +
      billNumber(
        item.line_total
      ),
    0
  );

const paidAmount =
  firstBillAmount([
    source.paid_amount,
    source.odenen_tutar,
    source.payment_total,
    source.total_paid,
    source.paid,
    source.odenen,

    summary.paid_amount,
    summary.odenen_tutar,
    summary.payment_total,
    summary.total_paid,
    summary.paid,
  ]);

const apiRemaining =
  firstBillAmount([
    source.remaining_amount,
    source.kalan_tutar,
    source.balance_amount,
    source.balance,
    source.remaining,
    source.kalan,

    summary.remaining_amount,
    summary.kalan_tutar,
    summary.balance_amount,
    summary.balance,
    summary.remaining,
  ]);

const directTotalAmount =
  firstBillAmount([
    source.total_amount,
    source.toplam_tutar,
    source.grand_total,
    source.total,
    source.genel_toplam,
    source.order_total,
    source.orders_total,

    summary.total_amount,
    summary.toplam_tutar,
    summary.grand_total,
    summary.total,
    summary.order_total,
    summary.orders_total,
  ]);

const totalAmount =
  directTotalAmount > 0
    ? directTotalAmount
    : itemsTotal > 0
    ? itemsTotal
    : paidAmount +
      apiRemaining;

const calculatedRemaining =
  Math.max(
    totalAmount -
      paidAmount,
    0
  );

const remainingAmount =
  apiRemaining > 0
    ? apiRemaining
    : calculatedRemaining;

return {
  ...source,

  items,

  total_amount:
    totalAmount,

  paid_amount:
    paidAmount,

  remaining_amount:
    remainingAmount,

  currency:
    source.currency ||
    source.para_birimi ||
    items[0]?.currency ||
    "TRY",
};



}

function hasPublicPriceOptions(item) {
  return normalizePublicPriceOptions(item?.price_options).length > 1;
}

function getPublicItemPriceText(item) {
  const options = normalizePublicPriceOptions(item?.price_options);

  // ✅ Sadece birden fazla gerçek seçenek varsa "başlayan" yazsın
  if (options.length > 1) {
    const prices = options
      .map((opt) => Number(opt.price || 0))
      .filter((x) => x > 0);

    const min = Math.min(...prices);
    const currency = options[0]?.currency || item?.currency || "TRY";

    return `${moneyText(min, currency)}’den başlayan`;
  }

  return moneyText(item?.price, item?.currency || "TRY");
}

// ✅ Trend alanında seçenekli ürünleri sade gösterir.
// Örnek: 80 TRY - 200 TRY
function getPublicTrendPriceText(item) {
  const options = normalizePublicPriceOptions(item?.price_options);

  if (options.length > 1) {
    const prices = options
      .map((opt) => Number(opt.price || 0))
      .filter((x) => x > 0);

    const min = Math.min(...prices);
    const max = Math.max(...prices);
    const currency = options[0]?.currency || item?.currency || "TRY";

    if (min === max) return moneyText(min, currency);

    return `${moneyText(min, currency)} - ${moneyText(max, currency)}`;
  }

  return moneyText(item?.price, item?.currency || "TRY");
}

/* 🔗 Sosyal ikon */
function SocialIcon({ href, label }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        width: 42,
        height: 42,
        borderRadius: "50%",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 6px 16px rgba(0,0,0,.25)",
        fontWeight: 700,
        color: "#0b1d2d",
        textDecoration: "none"
      }}
    >
      {label}
    </a>
  );
}

// ✅ EKLENDI: Basit TextField bileşeni (MUI kullanmamak için)
function TextField({
  label,
  fullWidth,
  margin,
  value,
  onChange,
  type,
  multiline,
  rows,
  readOnly = false,
}) {
  const inputStyle = {
    width: fullWidth ? "100%" : "auto",
    boxSizing: "border-box",
    padding: "12px 13px",
    borderRadius: 14,
    border: "1px solid #dbe3ef",
    fontSize: 15,
    fontWeight: 800,
    color: "#0b1d2d",
    background: "#ffffff",
    outline: "none",
    boxShadow: "inset 0 1px 0 rgba(15,23,42,0.03)",
  };

  return (
    <div
      style={{
        marginBottom: margin === "normal" ? 14 : 0,
        background: "#ffffff",
        borderRadius: 18,
        padding: "10px 10px 11px",
        border: "1px solid #e5eaf2",
        boxShadow: "0 6px 18px rgba(15,23,42,0.06)",
      }}
    >
      <label
        style={{
          display: "block",
          marginBottom: 7,
          fontSize: 12,
          fontWeight: 950,
          color: "#0b1d2d",
          letterSpacing: ".2px",
        }}
      >
        {label}
      </label>

      {multiline ? (
        <textarea
          rows={rows}
          value={value}
          onChange={onChange}
          style={{
            ...inputStyle,
            minHeight: rows ? rows * 28 : 84,
            resize: "vertical",
            lineHeight: "20px",
          }}
        />
      ) : (
      <input
  type={type || "text"}
  value={value}
  onChange={onChange}
  readOnly={readOnly}
  style={{
    ...inputStyle,

    background:
      readOnly
        ? "#F8FAFC"
        : "#FFFFFF",

    cursor:
      readOnly
        ? "not-allowed"
        : "text",
  }}
/>
      )}
    </div>
  );
}

function ProductImageBox({
  src,
  alt = "",
  height = 165,
  radiusTop = 0,
  radiusBottom = 0,
}) {
  const imageSrc = src || `${IMAGE_BASE}/default.jpg`;

  return (
    <div
      className="menu-product-img"
      style={{
        height,
        position: "relative",
        overflow: "hidden",
        borderTopLeftRadius: radiusTop,
        borderTopRightRadius: radiusTop,
        borderBottomLeftRadius: radiusBottom,
        borderBottomRightRadius: radiusBottom,
        background:
          "radial-gradient(circle at 20% 15%, rgba(255,159,28,.18), transparent 32%), linear-gradient(135deg, #ffffff 0%, #eef2f7 100%)",
        padding: 12,
        boxSizing: "border-box",
        borderBottom: "1px solid #eef0f3",
      }}
    >
      <div
        className="menu-photo-frame"
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 22,
          overflow: "hidden",
          background: "#fff",
          boxShadow:
            "0 12px 26px rgba(15,23,42,.16), inset 0 0 0 1px rgba(255,255,255,.65)",
          position: "relative",
        }}
      >
        <img
          src={imageSrc}
          alt={alt}
          style={{
            width: "100%",
            height: "100%",
           objectFit: "cover",
objectPosition: "center center",
            objectPosition: "center",
            display: "block",
          }}
          onError={(e) => {
            e.currentTarget.src = `${IMAGE_BASE}/default.jpg`;
          }}
        />

        <div
          className="menu-photo-shine"
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(120deg, transparent 0%, rgba(255,255,255,.35) 45%, transparent 70%)",
            transform: "translateX(-120%)",
            pointerEvents: "none",
          }}
        />
      </div>
    </div>
  );
}

function getPublicQrTable() {
  const hash =
    window.location.hash ||
    "";

  const questionIndex =
    hash.indexOf("?");

  const hashQuery =
    questionIndex >= 0
      ? hash.slice(
          questionIndex + 1
        )
      : "";

  const normalQuery =
    window.location.search
      ? window.location.search.slice(
          1
        )
      : "";

  const params =
    new URLSearchParams(
      hashQuery ||
      normalQuery
    );

  return {
    masa:
      String(
        params.get("masa") ||
        ""
      ).trim(),

    salon:
      String(
        params.get("salon") ||
        ""
      ).trim(),
  };
}

export default function PublicMenu() {
  const { kurumId } =
    useParams();

  const qrTableInfo =
    useMemo(
      () =>
        getPublicQrTable(),
      []
    );

  const qrTableNo =
    qrTableInfo.masa;

  const qrSalonName =
    qrTableInfo.salon;

  const [lang, setLang] = useState(detectLang());

  // ✅ ESKİ ÇALIŞAN STATE'LER - SİLİNMEYECEK
  const [menuLangs, setMenuLangs] = useState([]);
  const [sections, setSections] = useState([]);
  const [contact, setContact] = useState({});
  const [googleReview, setGoogleReview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingBusinessName, setLoadingBusinessName] = useState("");

  const loadingStartRef = useRef(Date.now());
  const loadingTimerRef = useRef(null);

 const [menuOptions, setMenuOptions] = useState({
  garson_cagir_active: true,
  siparis_active: true,

  // ✅ Akıllı hesap / ödeme özellikleri
  hesap_odeme_active: false,
  hesap_bolustur_active: false,
  bahsis_active: true,
  yorum_active: true,

  theme_default: "standard",
  theme_options: [
    "standard",
    "luxury_gold",
    "coffee",
    "modern_dark",
    "nature"
  ],

  // ✅ Eski kurumlar trend olarak çalışmaya devam eder.
  showcase_mode: "trend",
  showcase_category_keys: []
});

const [openSection, setOpenSection] = useState(null);
const [openItem, setOpenItem] = useState(null);

// ✅ Menü vitrini içinde seçilen ana bölüm
const [activeShowcaseKey, setActiveShowcaseKey] = useState(null);



const [search, setSearch] = useState("");
const [showThemePanel, setShowThemePanel] = useState(false);
const [activeTheme, setActiveTheme] = useState("standard");
const themeStyle =
  QR_THEME_STYLES[activeTheme] || QR_THEME_STYLES.standard;

const isDarkTheme = [
  "modern_dark",
  "gold_black",
  "business",
  "neon",
  "night"
].includes(activeTheme);





const pageBackground = isDarkTheme
  ? `radial-gradient(circle at top, ${themeStyle.primary}26, transparent 32%),
     linear-gradient(180deg, ${themeStyle.dark} 0%, #020617 46%, #0f172a 100%)`
  : `radial-gradient(circle at top, ${themeStyle.primary}26, transparent 30%),
     linear-gradient(180deg, ${themeStyle.dark} 0%, #071421 42%, #111827 100%)`;

const sectionTitleColor = "#ffffff";
const sectionSubColor = "rgba(255,255,255,0.70)";

const softPanelBg = "rgba(255,255,255,0.08)";
const softPanelBorder = "rgba(255,255,255,0.13)";
const softCardBg = "rgba(255,255,255,0.96)";

  /* ⭐ trend modal */
  const [activeItem, setActiveItem] = useState(null);

   /* slider */
  const sliderRef = useRef(null);
  const autoRef = useRef(null);

  // ✅ Ana sayfaya / en üste dönmek için
  const menuTopRef = useRef(null);

  // ✅ Kategoriye basınca o kategori ekranın üstüne gelsin
  const categoryRefs = useRef({});

  // ✅ EKLENDI: Sepet state ve sipariş formu state'leri
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [customerName, setCustomerName] = useState("");
const [tableNo, setTableNo] =
  useState(qrTableNo);


  const [orderNote, setOrderNote] = useState("");

  // ✅ Akıllı hesap / hesap bölüştürme modalı
  const [showBillModal, setShowBillModal] = useState(false);


const [billLoading, setBillLoading] = useState(false);
const [billSubmitting, setBillSubmitting] = useState(false);
const [tableBillData, setTableBillData] = useState(null);
const [billCustomerName, setBillCustomerName] = useState("");
const [
  billTableNo,
  setBillTableNo,
] = useState(qrTableNo);

const [billMode, setBillMode] = useState("full");
const [billAmount, setBillAmount] = useState("");
const [billPeopleCount, setBillPeopleCount] = useState("");
const [billTipAmount, setBillTipAmount] = useState("");
const [billSelectedItems, setBillSelectedItems] = useState([]);
  
  // ✅ GARSON ÇAĞIRMA MODAL STATELERİ
   const [showWaiterModal, setShowWaiterModal] = useState(false);
const [
  waiterMasaNo,
  setWaiterMasaNo,
] = useState(qrTableNo);

  const [waiterAd, setWaiterAd] = useState("");

useEffect(() => {
  if (!qrTableNo) {
    return;
  }

  setTableNo(
    qrTableNo
  );

  setBillTableNo(
    qrTableNo
  );

  setWaiterMasaNo(
    qrTableNo
  );
}, [qrTableNo]);




  // ✅ Profesyonel garson bildirimi
  // ✅ Tüm sistem için profesyonel çok dilli bildirim
  const [appNotice, setAppNotice] = useState(null);
  const noticeTimerRef = useRef(null);
  // ✅ GARSON ÇAĞIRMA FONKSİYONU


const showAppNotice = (
  type,
  titleKey,
  textKey,
  position = "bottom",
  icon = null
) => {
  if (noticeTimerRef.current) {
    clearTimeout(noticeTimerRef.current);
  }

  setAppNotice({
    type,
    title: t(titleKey, lang),
    text: t(textKey, lang),
    position,
    icon,
  });

  noticeTimerRef.current = setTimeout(() => {
    setAppNotice(null);
  }, position === "center" ? 1800 : 3600);
};

const showPlainNotice = (
  type,
  title,
  text,
  position = "bottom",
  icon = null
) => {
  if (noticeTimerRef.current) {
    clearTimeout(noticeTimerRef.current);
  }

  setAppNotice({
    type,
    title,
    text,
    position,
    icon,
  });

  noticeTimerRef.current = setTimeout(() => {
    setAppNotice(null);
  }, position === "center" ? 1900 : 3800);
};

const loadTableBill = async (forcedTableNo = null) => {
const cleanTableNo =
  String(
    forcedTableNo ||
    qrTableNo ||
    billTableNo ||
    ""
  ).trim();


  if (!cleanTableNo) {
    showPlainNotice(
      "warning",
      "Masa numarası gerekli",
      "Hesabı görebilmek için masa numarasını yazın.",
      "bottom",
      "⚠️"
    );
    return;
  }

  setBillLoading(true);

  try {
    const res = await fetch(
      `${API_BASE}/public/masa-hesap?kurum_id=${encodeURIComponent(
        kurumId
      )}&masa_no=${encodeURIComponent(cleanTableNo)}`
    );

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json?.ok === false) {
      throw new Error(json?.message || "Masa hesabı alınamadı");
    }

  const normalizedBill =
  normalizeTableBillData(
    json.data ||
    json.bill ||
    json.account ||
    json
  );

setTableBillData(
  normalizedBill
);

setBillSelectedItems(
  []
);

setBillMode(
  "full"
);

  } catch (err) {
    console.error("Masa hesabı alınamadı:", err);
    showPlainNotice(
      "error",
      "Hesap alınamadı",
      err.message || "Masa hesabı alınamadı.",
      "bottom",
      "❌"
    );
  } finally {
    setBillLoading(false);
  }
};

const toggleBillItem = (lineUid) => {
  setBillSelectedItems((prev) =>
    prev.includes(lineUid)
      ? prev.filter((x) => x !== lineUid)
      : [...prev, lineUid]
  );
};

const getBillRequestAmount = () => {
  const normalizedBill =
    normalizeTableBillData(
      tableBillData
    );

  const remaining =
    billNumber(
      normalizedBill
        .remaining_amount
    );

  if (
    billMode === "full"
  ) {
    return remaining;
  }

  if (
    billMode === "items"
  ) {
    return (
      normalizedBill.items ||
      []
    )
      .filter((item) =>
        billSelectedItems.includes(
          item.line_uid
        )
      )
      .reduce(
        (sum, item) =>
          sum +
          billNumber(
            item.line_total
          ),
        0
      );
  }

  if (
    billMode === "amount"
  ) {
    return billNumber(
      billAmount
    );
  }

  if (
    billMode === "people"
  ) {
    const count =
      Math.max(
        0,

        Number(
          billPeopleCount ||
          0
        )
      );

    return count > 0
      ? remaining / count
      : 0;
  }

  return 0;
};

const submitBillPaymentRequest = async () => {
  if (!tableBillData) {
    showPlainNotice(
      "warning",
      "Masa hesabı yok",
      "Önce masa numarasıyla hesabı getir.",
      "bottom",
      "⚠️"
    );
    return;
  }

  if (!String(billCustomerName || "").trim()) {
    showPlainNotice(
      "warning",
      "Adınızı yazın",
      "Ödeme talebi için adınızı yazmanız gerekir.",
      "bottom",
      "⚠️"
    );
    return;
  }

  if (billMode === "items" && billSelectedItems.length === 0) {
    showPlainNotice(
      "warning",
      "Ürün seçilmedi",
      "Kendi payınızı ödemek için ürün seçin.",
      "bottom",
      "☑️"
    );
    return;
  }

  if (billMode === "people" && Number(billPeopleCount || 0) <= 0) {
    showPlainNotice(
      "warning",
      "Kişi sayısı gerekli",
      "Hesabı bölmek için kişi sayısını yazın.",
      "bottom",
      "👥"
    );
    return;
  }

  const baseAmount = getBillRequestAmount();
  const tipAmount = Math.max(
    Number(String(billTipAmount || "0").replace(",", ".") || 0),
    0
  );
  const finalAmount = baseAmount + tipAmount;

  if (finalAmount <= 0) {
    showPlainNotice(
      "warning",
      "Tutar geçersiz",
      "Ödeme tutarı sıfırdan büyük olmalı.",
      "bottom",
      "⚠️"
    );
    return;
  }

  const selectedItems =
    billMode === "items"
      ? (tableBillData.items || []).filter((item) =>
          billSelectedItems.includes(item.line_uid)
        )
      : [];

  setBillSubmitting(true);

  try {
    const res = await fetch(`${API_BASE}/public/masa-odeme-talep`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        kurum_id: kurumId,
masa_no:
  qrTableNo ||
  billTableNo,

        musteri_adi: billCustomerName,
        telefon: "",
        payment_type: billMode,
        amount: baseAmount,
        tip_amount: tipAmount,
        people_count:
          billMode === "people" ? Number(billPeopleCount || 0) : null,
        selected_items: selectedItems,
        note: "",
      }),
    });

    const json = await res.json().catch(() => ({}));

    if (!res.ok || json?.ok === false) {
      throw new Error(json?.message || "Ödeme talebi oluşturulamadı");
    }

    showPlainNotice(
      "success",
      "Talep işletmeye gönderildi",
      "İşletme panelinde ödeme talebiniz görünecek.",
      "center",
      "💳"
    );

    setShowBillModal(false);
    setTableBillData(null);
    setBillMode("full");
    setBillAmount("");
    setBillPeopleCount("");
    setBillTipAmount("");
    setBillSelectedItems([]);
  } catch (err) {
    console.error("Ödeme talebi hatası:", err);
    showPlainNotice(
      "error",
      "Talep gönderilemedi",
      err.message || "Lütfen tekrar deneyin.",
      "bottom",
      "❌"
    );
  } finally {
    setBillSubmitting(false);
  }
};
const callWaiter = async () => {
  if (!waiterMasaNo.trim() && !waiterAd.trim()) {
    showAppNotice("warning", "missingInfoTitle", "missingWaiterText");
    return;
  }

  try {
    const res = await fetch(`${API_BASE}/public/qr-orders/call-waiter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kurum_id: kurumId,
masa_no:
  qrTableNo ||
  waiterMasaNo ||
  "Belirtilmemiş",

        musteri_adi: waiterAd || "Misafir",
        telefon: ""
      })
    });

    if (res.ok) {
      setShowWaiterModal(false);
setWaiterMasaNo(
  qrTableNo
);

      setWaiterAd("");

      showAppNotice(
        "success",
        "waiterSuccessTitle",
        "waiterSuccessText",
        "center",
        "🔔"
      );

    } else {
      showAppNotice("error", "processErrorTitle", "processErrorText");
    }
  } catch (err) {
    console.error("Garson çağırma hatası:", err);
    showAppNotice("error", "connectionErrorTitle", "connectionErrorText");
  }
};


  // ✅ EKLENDI: Sepet işlemleri
const addToCart = (item, option = null) => {
  const selectedOption = option
    ? {
        id: option.id,
        label: option.label,
        price: Number(option.price || 0),
        currency: option.currency || item.currency || "TRY",
      }
    : null;

  const cartId = selectedOption
    ? `${item.id}-${selectedOption.id}`
    : String(item.id);

  const cartItem = {
    ...item,
    id: cartId,
    product_id: item.id,
    title: selectedOption
      ? `${item.title} - ${selectedOption.label}`
      : item.title,
    price: selectedOption
      ? selectedOption.price
      : Number(item.price || 0),
    currency: selectedOption
      ? selectedOption.currency
      : item.currency || "TRY",
    selected_option: selectedOption,
  };

  setCart(prev => {
    const existing = prev.find(i => i.id === cartId);

    if (existing) {
      return prev.map(i =>
        i.id === cartId
          ? { ...i, quantity: i.quantity + 1 }
          : i
      );
    }

    return [...prev, { ...cartItem, quantity: 1 }];
  });

  showAppNotice(
    "success",
    "cartAddedTitle",
    "cartAddedText",
    "center",
    "✓"
  );
};


  const removeFromCart = (itemId) => {
    setCart(prev => prev.filter(i => i.id !== itemId));
  };

  const updateQuantity = (itemId, newQty) => {
    if (newQty <= 0) {
      removeFromCart(itemId);
      return;
    }
    setCart(prev => prev.map(i => i.id === itemId ? { ...i, quantity: newQty } : i));
  };

  const cartTotal = useMemo(() => {
    return cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  }, [cart]);

  const canShowBillActions =
    menuOptions.hesap_odeme_active === true ||
    menuOptions.hesap_bolustur_active === true;

// ✅ EKLENDI: Sipariş gönderme

const submitOrder = async () => {
  if (!customerName.trim()) {
    showAppNotice("warning", "missingInfoTitle", "orderNameMissingText");
    return;
  }

  if (cart.length === 0) {
    showAppNotice("warning", "emptyCart", "emptyCartText");
    return;
  }

  const orderData = {
    kurum_id: kurumId,
    musteri_adi: customerName,
    telefon: "",

masa_no:
  String(
    qrTableNo ||
    tableNo ||
    ""
  ).trim() || null,


    siparis_notu: orderNote || null,
 items: cart.map(item => ({
  id: item.product_id || item.id,
  title: item.title,
  price: item.price,
  currency: item.currency || "TRY",
  quantity: item.quantity
})),
    toplam_tutar: cartTotal,
    durum: "yeni"
  };

  try {
    const res = await fetch(API_ORDERS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(orderData)
    });

    if (!res.ok) throw new Error("Sunucu hatası");

    const result = await res.json();

    console.log("Sipariş oluştu:", result);

    showAppNotice("success", "orderSuccessTitle", "orderSuccessText");
    // Sepeti ve formu sıfırla
    setCart([]);
    setCustomerName("");
setTableNo(
  qrTableNo
);

    setOrderNote("");
    setShowCart(false);

    // Profesyonel bildirim showAppNotice ile gösteriliyor


  } catch (err) {
    console.error("Sipariş hatası:", err);

    showAppNotice("error", "processErrorTitle", "processErrorText");


    // Profesyonel bildirim showAppNotice ile gösteriliyor

  }
};


useEffect(() => {
  return () => {
    if (noticeTimerRef.current) {
      clearTimeout(noticeTimerRef.current);
    }

    if (loadingTimerRef.current) {
      clearTimeout(loadingTimerRef.current);
    }
  };
}, []);

  useEffect(() => {
    if (!kurumId) return;

    setLoading(true);
    loadingStartRef.current = Date.now();

    if (loadingTimerRef.current) {
      clearTimeout(loadingTimerRef.current);
    }

fetch(`${API_MENU}?kurum_id=${kurumId}&lang=${lang}`)
  .then(r => r.json())
  .then(async (menuRes) => {
const realKurumId =
  menuRes.kurum_id ||
  menuRes.kurumId ||
  menuRes.id ||
  menuRes.data?.kurum_id ||
  menuRes.data?.kurumId ||
  menuRes.data?.id ||
  menuRes.kurum?.id ||
  menuRes.business?.id ||
  kurumId;

console.log("MENU RES:", menuRes);
console.log("REAL KURUM ID:", realKurumId);

 const iletisimRes = await fetch(
  `${API_ILETISIM}?kurum_id=${realKurumId}&lang=tr`
).then(r => r.json());

        const allowed = menuRes.menu_langs?.length ? menuRes.menu_langs : ["tr"];
        setMenuLangs(allowed);

        if (!allowed.includes(lang)) {
          setLang(allowed[0]);
          return;
        }

const contactData = iletisimRes.data || {};

setContact(contactData);
setLoadingBusinessName(
  contactData.kurum_adi ||
  contactData.business_name ||
  contactData.title ||
  menuRes.kurum_adi ||
  menuRes.business_name ||
  "QR Menü"
);

setGoogleReview(menuRes.google_review || null);

const defaultTheme = menuRes.theme_default || "standard";
const themeOptions = Array.isArray(menuRes.theme_options)
  ? menuRes.theme_options
  : [
      "standard",
      "luxury_gold",
      "coffee",
      "modern_dark",
      "nature"
    ];

setMenuOptions({
  garson_cagir_active:
    menuRes.garson_cagir_active !== false,

  siparis_active:
    menuRes.siparis_active !== false,

  // ✅ Panelden açılırsa müşteri public ekranda görünür.
  hesap_odeme_active:
    menuRes.hesap_odeme_active === true,

  hesap_bolustur_active:
    menuRes.hesap_bolustur_active === true,

  bahsis_active:
    menuRes.bahsis_active !== false,

  yorum_active:
    menuRes.yorum_active !== false,

  theme_default: defaultTheme,
  theme_options: themeOptions,

  // ✅ Alan yoksa eski trend sistemi devam eder.
  showcase_mode:
    menuRes.showcase_mode === "menu_showcase"
      ? "menu_showcase"
      : "trend",

  showcase_category_keys:
    normalizePublicArray(
      menuRes.showcase_category_keys
    )
});


setActiveTheme(defaultTheme);


        const cleaned = (menuRes.sections || []).map(sec => ({
          ...sec,
          title: resolveLang(sec, "title", lang),
          categories: sec.categories.map(cat => ({
            ...cat,
            title: resolveLang(cat, "title", lang),
         items: cat.items.map(item => ({
  ...item,
  title: resolveLang(item, "title", lang),
  description: resolveLang(item, "description", lang),
  price_options: normalizePublicPriceOptions(item.price_options),
}))
          }))
        }));

        setSections(cleaned);

        const minLoadingTime = 2200; // 2.2 saniye ekranda kalsın
        const elapsed = Date.now() - loadingStartRef.current;
        const remaining = Math.max(0, minLoadingTime - elapsed);

        loadingTimerRef.current = setTimeout(() => {
          setLoading(false);
        }, remaining);

      });
  }, [kurumId, lang]);

 /* ⭐ TREND */
const trendItems = useMemo(
  () =>
    sections
      .flatMap(s => s.categories)
      .flatMap(c => c.items)
      .filter(i => i.is_trend),
  [sections]
);

// ✅ Panelden seçilen vitrin ana kategorilerini sırasıyla getirir.
const showcaseCategoryKeys = useMemo(
  () =>
    normalizePublicArray(
      menuOptions.showcase_category_keys
    ),
  [menuOptions.showcase_category_keys]
);

const showcaseSections = useMemo(() => {
  const sectionMap = new Map(
    sections.map((section) => [
      String(section.category_key || "").trim(),
      section,
    ])
  );

  return showcaseCategoryKeys
    .map((key) => sectionMap.get(key))
    .filter(Boolean);
}, [sections, showcaseCategoryKeys]);

const requestedMenuShowcase =
  menuOptions.showcase_mode === "menu_showcase";

// ✅ Kategori sonradan silinmişse boş ekran çıkarmadan trende döner.
const useMenuShowcase =
  requestedMenuShowcase &&
  showcaseSections.length > 0;


const activeShowcaseSection = useMemo(() => {
  if (!useMenuShowcase) return null;

  return (
    showcaseSections.find(
      (section) =>
        String(section.category_key || "") ===
        String(activeShowcaseKey || "")
    ) ||
    showcaseSections[0] ||
    null
  );
}, [
  useMenuShowcase,
  showcaseSections,
  activeShowcaseKey,
]);

// ✅ Menü vitrini açıldığında ilk kart otomatik seçilir.
// Panelden sıra veya kategori değişirse geçersiz seçim güvenle yenilenir.
useEffect(() => {
  if (!useMenuShowcase) {
    if (activeShowcaseKey !== null) {
      setActiveShowcaseKey(null);
    }

    return;
  }

  const firstKey = String(
    showcaseSections[0]?.category_key || ""
  ).trim();

  const activeKeyExists = showcaseSections.some(
    (section) =>
      String(section.category_key || "").trim() ===
      String(activeShowcaseKey || "").trim()
  );

  if (!activeKeyExists && firstKey) {
    setActiveShowcaseKey(firstKey);
    setOpenSection(null);
    setOpenItem(null);
  }
}, [
  useMenuShowcase,
  showcaseSections,
  activeShowcaseKey,
]);

// ✅ Trend modunda bütün bölümler görünür.
// Menü vitrini modunda yalnızca seçili vitrinin alt kategorileri görünür.
const categorySourceSections = useMemo(() => {
  if (!useMenuShowcase) {
    return sections;
  }

  return activeShowcaseSection
    ? [activeShowcaseSection]
    : [];
}, [
  useMenuShowcase,
  sections,
  activeShowcaseSection,
]);

/* 🔍 ARAMA */
const filteredSections = useMemo(() => {
  const q = String(search || "")
    .trim()
    .toLowerCase();

  if (!q) {
    return categorySourceSections;
  }

  return categorySourceSections
    .map((sec) => ({
      ...sec,

      categories: (sec.categories || [])
        .map((cat) => ({
          ...cat,

          items: (cat.items || []).filter(
            (item) =>
              String(item.title || "")
                .toLowerCase()
                .includes(q) ||
              String(item.description || "")
                .toLowerCase()
                .includes(q)
          ),
        }))
        .filter(
          (cat) => cat.items.length > 0
        ),
    }))
    .filter(
      (sec) => sec.categories.length > 0
    );
}, [
  categorySourceSections,
  search,
]);

// ✅ Menü vitrini modunda üst slider her zaman vitrin kartlarından oluşur.
// Trend modunda eski trend ürünler aynı şekilde devam eder.
const upperSliderCount = useMenuShowcase
  ? showcaseSections.length
  : trendItems.length;

const hasUpperSlider =
  upperSliderCount > 0;

/* ▶️ Üst vitrin / trend otomatik slider */
useEffect(() => {
  if (autoRef.current) {
    clearInterval(autoRef.current);
    autoRef.current = null;
  }

  const slider = sliderRef.current;

  if (!upperSliderCount || !slider) {
    return undefined;
  }

  slider.scrollTo({
    left: 0,
    behavior: "auto",
  });

  autoRef.current = setInterval(() => {
    if (
      slider.scrollLeft +
        slider.clientWidth >=
      slider.scrollWidth - 5
    ) {
      slider.scrollTo({
        left: 0,
        behavior: "smooth",
      });

      return;
    }

    slider.scrollBy({
      left: 260,
      behavior: "smooth",
    });
  }, 2500);

  return () => {
    if (autoRef.current) {
      clearInterval(autoRef.current);
      autoRef.current = null;
    }
  };
}, [
  upperSliderCount,
  useMenuShowcase,
]);





  /* body scroll lock (PWA uyum) */
  useEffect(() => {
    document.body.style.overflow = activeItem ? "hidden" : "auto";
  }, [activeItem]);

   if (loading) {
    const displayName =
      loadingBusinessName ||
      contact?.kurum_adi ||
      "QR Menü";

    return (
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          background:
            "radial-gradient(circle at top, rgba(255,138,0,.28), transparent 34%), linear-gradient(180deg, #071421 0%, #0b1d2d 48%, #071421 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          boxSizing: "border-box",
          color: "#fff",
          overflow: "hidden",
          position: "relative"
        }}
      >
        <style>{`
          @keyframes qrLoaderFloat {
            0%, 100% {
              transform: translateY(0) scale(1);
            }
            50% {
              transform: translateY(-8px) scale(1.03);
            }
          }

          @keyframes qrLoaderSpin {
            to {
              transform: rotate(360deg);
            }
          }

 
          @keyframes qrLoaderPulse {
            0%, 100% {
              opacity: .35;
              transform: scale(.94);
            }
            50% {
              opacity: 1;
              transform: scale(1);
            }
          }

          @keyframes qrLoaderBar {
            0% {
              transform: translateX(-110%);
            }
            100% {
              transform: translateX(110%);
            }
          }

          .qr-loader-card {
            animation: qrLoaderFloat 2.2s ease-in-out infinite;
          }

          .qr-loader-ring {
            animation: qrLoaderSpin 1.4s linear infinite;
          }

          .qr-loader-dot {
            animation: qrLoaderPulse 1.2s ease-in-out infinite;
          }

          .qr-loader-dot:nth-child(2) {
            animation-delay: .15s;
          }

          .qr-loader-dot:nth-child(3) {
            animation-delay: .3s;
          }

          .qr-loader-bar::after {
            content: "";
            position: absolute;
            inset: 0;
            width: 55%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,.9), transparent);
            animation: qrLoaderBar 1.35s ease-in-out infinite;
          }
        `}</style>

        <div
          style={{
            position: "absolute",
            width: 260,
            height: 260,
            borderRadius: "50%",
            background: "rgba(255,138,0,.16)",
            filter: "blur(40px)",
            top: "18%",
            left: "50%",
            transform: "translateX(-50%)"
          }}
        />

        <div
          className="qr-loader-card"
          style={{
            width: "100%",
            maxWidth: 390,
            background: "rgba(255,255,255,.10)",
            border: "1px solid rgba(255,255,255,.18)",
            backdropFilter: "blur(18px)",
            borderRadius: 34,
            padding: "34px 24px",
            textAlign: "center",
            boxShadow: "0 28px 80px rgba(0,0,0,.38)",
            position: "relative",
            zIndex: 2
          }}
        >
          <div
            style={{
              width: 104,
              height: 104,
              margin: "0 auto 22px",
              borderRadius: "50%",
              background: "rgba(255,255,255,.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative"
            }}
          >
            <div
              className="qr-loader-ring"
              style={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                border: "4px solid rgba(255,255,255,.18)",
                borderTopColor: "#ff8a00",
                borderRightColor: "#ffb347"
              }}
            />

            <div
              style={{
                width: 68,
                height: 68,
                borderRadius: 22,
                background: "linear-gradient(135deg, #ff9f1c, #ff7a00)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#0b1d2d",
                fontSize: 34,
                fontWeight: 900,
                boxShadow: "0 14px 34px rgba(255,138,0,.38)"
              }}
            >
              🍽️
            </div>
          </div>

          <div
            style={{
              fontSize: 14,
              fontWeight: 800,
              letterSpacing: 1.5,
              textTransform: "uppercase",
              color: "#ffb347",
              marginBottom: 8
            }}
          >
            {displayName}
          </div>

          <h2
            style={{
              margin: 0,
              fontSize: "clamp(24px, 6vw, 32px)",
              fontWeight: 950,
              lineHeight: 1.15
            }}
          >
            Menü yükleniyor
          </h2>

          <p
            style={{
              margin: "10px auto 22px",
              maxWidth: 280,
              fontSize: 14,
              lineHeight: "21px",
              color: "rgba(255,255,255,.72)",
              fontWeight: 600
            }}
          >
            Lezzetler ve kategoriler hazırlanıyor.
          </p>

          <div
            className="qr-loader-bar"
            style={{
              width: "100%",
              height: 8,
              borderRadius: 999,
              background: "rgba(255,255,255,.16)",
              overflow: "hidden",
              position: "relative",
              marginBottom: 18
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 8
            }}
          >
            <span
              className="qr-loader-dot"
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "#ff8a00",
                display: "block"
              }}
            />
            <span
              className="qr-loader-dot"
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "#ffb347",
                display: "block"
              }}
            />
            <span
              className="qr-loader-dot"
              style={{
                width: 9,
                height: 9,
                borderRadius: "50%",
                background: "#ffffff",
                display: "block"
              }}
            />
          </div>
        </div>
      </div>
    );
  }
return (
    <div
      ref={menuTopRef}
      data-theme={activeTheme}
     style={{
  background: pageBackground,
  minHeight: "100vh",
  position: "relative",
  color: sectionTitleColor,
  paddingBottom: 124,
  overflowX: "hidden",
  fontFamily:
    "Inter, Segoe UI, Roboto, system-ui, -apple-system, BlinkMacSystemFont, Arial, sans-serif",
  WebkitFontSmoothing: "antialiased",
  textRendering: "geometricPrecision"
}}
    >

<style>{`

  @keyframes menuFadeUp {
    from {
      opacity: 0;
      transform: translateY(14px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes cartBackdropIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes cartSheetUp {
    0% {
      opacity: 0;
      transform: translateY(100%) scale(.96);
    }
    60% {
      opacity: 1;
      transform: translateY(-10px) scale(1.01);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes cartItemIn {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes themePanelIn {
    from {
      opacity: 0;
      transform: translateY(-10px) scale(.96);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes themeSelectedPulse {
    0%, 100% {
      box-shadow: 0 0 0 0 rgba(255,138,0,.30);
    }
    50% {
      box-shadow: 0 0 0 8px rgba(255,138,0,0);
    }
  }

  .cart-backdrop-pro {
    animation: cartBackdropIn .22s ease both;
  }

  .cart-sheet-pro {
    animation: cartSheetUp .42s cubic-bezier(.2,.9,.2,1) both;
  }

  .cart-item-pro {
    animation: cartItemIn .28s ease both;
  }

  .theme-panel-pro {
    animation: themePanelIn .25s cubic-bezier(.2,.9,.2,1) both;
  }

  .theme-option-pro {
    transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;
  }

  .theme-option-pro:active {
    transform: scale(.98);
  }

  @media (hover: hover) {
    .theme-option-pro:hover {
      transform: translateY(-2px);
      box-shadow: 0 12px 26px rgba(15,23,42,.16) !important;
    }
  }

   .theme-selected-dot {
    animation: themeSelectedPulse 1.5s ease infinite;
  }

  @keyframes heroLogoFloat {
    0%, 100% {
      transform: translateY(0) scale(1);
    }
    50% {
      transform: translateY(-5px) scale(1.03);
    }
  }

  @keyframes heroTitleGlow {
    0%, 100% {
      text-shadow: 0 4px 18px rgba(0,0,0,.35);
    }
    50% {
      text-shadow: 0 6px 26px rgba(255,138,0,.30);
    }
  }

  .hero-logo-pro {
    animation: heroLogoFloat 2.4s ease-in-out infinite;
  }

  .hero-title-pro {
    animation: heroTitleGlow 2.8s ease-in-out infinite;
  }

  @media (hover: hover) {
    .menu-category-card-pro:hover {
      transform: translateY(-4px);
      box-shadow: 0 18px 38px rgba(0,0,0,.32) !important;
    }
  }

  @keyframes noticeCenterPop {
    0% {
      opacity: 0;
      transform: translate(-50%, -50%) scale(.72);
    }
    55% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1.08);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  @keyframes noticeBackdropFade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes noticeIconPulse {
    0% {
      transform: scale(.86);
      box-shadow: 0 0 0 0 rgba(34,197,94,.38);
    }
    70% {
      transform: scale(1.04);
      box-shadow: 0 0 0 18px rgba(34,197,94,0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(34,197,94,0);
    }
  }

  .notice-center-backdrop {
    animation: noticeBackdropFade .18s ease both;
  }

  .notice-center-card {
    animation: noticeCenterPop .38s cubic-bezier(.2,.9,.2,1) both;
  }

  .notice-center-icon {
    animation: noticeIconPulse 1.15s ease infinite;
  }


.menu-category-card-pro {
  animation: menuFadeUp .38s ease both;
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
}

.menu-category-card-pro:active {
  transform: scale(.985);
}

@keyframes menuProductSlideRight {
  from {
    opacity: 0;
    transform: translateX(26px) scale(.96);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes menuCategoryOpen {
  from {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    max-height: 2000px;
  }
}

.menu-products-open {
  animation: menuCategoryOpen .42s cubic-bezier(.2,.9,.2,1) both;
  overflow: hidden;
}

.menu-product-card {
  animation: menuProductSlideRight .42s cubic-bezier(.2,.9,.2,1) both;
  transition: transform .24s ease, box-shadow .24s ease, border-color .24s ease;
}

  .menu-product-card:active {
    transform: scale(.98);
  }

  @media (hover: hover) {
    .menu-product-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 14px 28px rgba(0,0,0,.14) !important;
    }

    .menu-product-card:hover .menu-product-img img {
      transform: scale(1.04);
    }
  }

  .menu-product-img img {
    transition: transform .45s ease;
  }

  @keyframes waiterModalBackdropIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes waiterModalCardIn {
    0% {
      opacity: 0;
      transform: translateY(24px) scale(.92);
    }
    60% {
      opacity: 1;
      transform: translateY(-6px) scale(1.02);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes waiterBellFloat {
    0%, 100% {
      transform: translateY(0) rotate(0deg);
    }
    35% {
      transform: translateY(-4px) rotate(-8deg);
    }
    70% {
      transform: translateY(-2px) rotate(8deg);
    }
  }

  .waiter-modal-backdrop-pro {
    animation: waiterModalBackdropIn .22s ease both;
  }

  .waiter-modal-card-pro {
    animation: waiterModalCardIn .36s cubic-bezier(.2,.9,.2,1) both;
  }

  .waiter-bell-pro {
    animation: waiterBellFloat 1.35s ease-in-out infinite;
  }


  @keyframes waiterToastIn {
    0% {
      opacity: 0;
      transform: translate(-50%, 24px) scale(.94);
    }
    60% {
      opacity: 1;
      transform: translate(-50%, -4px) scale(1.02);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, 0) scale(1);
    }
  }

  @keyframes waiterPulse {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255,138,0,.45);
    }
    70% {
      transform: scale(1.04);
      box-shadow: 0 0 0 14px rgba(255,138,0,0);
    }
    100% {
      transform: scale(1);
      box-shadow: 0 0 0 0 rgba(255,138,0,0);
    }
  }

  .waiter-toast {
    animation: waiterToastIn .45s cubic-bezier(.2,.9,.2,1) both;
  }

  .waiter-toast-icon {
    animation: waiterPulse 1.4s ease infinite;
  }

  .menu-product-card:hover .menu-product-img img,
  .menu-product-card:active .menu-product-img img {
    transform: scale(1.08);
  }

  .menu-product-card:hover .menu-photo-shine,
  .menu-product-card:active .menu-photo-shine {
    animation: menuShine .9s ease;
  }

  @keyframes menuShine {
    from {
      transform: translateX(-120%);
    }
    to {
      transform: translateX(120%);
    }
  }

`}</style>






{/* ===== PROFESYONEL TEMA SEÇİM BUTONU ===== */}
{menuOptions.theme_options?.length > 1 && (
  <div
    style={{
      position: "fixed",
      top: 16,
      right: 16,
      zIndex: 650
    }}
  >
    <button
      onClick={() => setShowThemePanel(!showThemePanel)}
      style={{
        width: 44,
        height: 44,
        borderRadius: "50%",
        border: "1px solid rgba(255,255,255,.65)",
        background:
          "linear-gradient(135deg, rgba(255,255,255,.98), rgba(255,255,255,.82))",
        boxShadow: "0 14px 34px rgba(15,23,42,.28)",
        fontSize: 19,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(14px)",
        color: "#0b1d2d"
      }}
      title="Tema seç"
    >
      🎨
    </button>

    {showThemePanel && (
      <div
        className="theme-panel-pro"
        style={{
          marginTop: 12,
          width: 248,
          maxHeight: "62vh",
          overflowY: "auto",
          background:
            "linear-gradient(180deg, rgba(255,255,255,.98), rgba(248,250,252,.96))",
        borderRadius: 20,
boxShadow: "0 18px 50px rgba(15,23,42,.28)",
padding: 10,
          border: "1px solid rgba(255,255,255,.82)",
          backdropFilter: "blur(18px)"
        }}
      >
        <div
          style={{
            padding: "8px 8px 12px",
            borderBottom: "1px solid #e5e7eb",
            marginBottom: 10
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontWeight: 900,
              color: "#64748b",
              letterSpacing: .8,
              textTransform: "uppercase"
            }}
          >
            Menü Teması
          </div>

          <div
            style={{
              marginTop: 4,
              fontSize: 15,
              fontWeight: 950,
              color: "#0b1d2d",
              display: "flex",
              alignItems: "center",
              gap: 8
            }}
          >
            <span>{themeStyle?.icon || "🎨"}</span>
            <span>
              {(QR_THEME_STYLES[activeTheme] || QR_THEME_STYLES.standard).name}
            </span>
          </div>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 9
          }}
        >
          {menuOptions.theme_options.map((themeId) => {
            const itemTheme = QR_THEME_STYLES[themeId] || {
              name: themeId,
              icon: "🎨",
              primary: "#ff8a00",
              dark: "#0b1d2d",
              bg: "#f8fafc",
              text: "#0b1d2d"
            };

            const selected = activeTheme === themeId;

            return (
              <button
                key={themeId}
                className="theme-option-pro"
                onClick={() => {
                  setActiveTheme(themeId);
                  setShowThemePanel(false);
                }}
                style={{
                  width: "100%",
                  padding: "8px 12px",
                  borderRadius: 15,
                  border: selected
                    ? `2px solid ${itemTheme.primary}`
                    : "1px solid #e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  background: selected
                    ? `linear-gradient(135deg, ${itemTheme.primary}20, #ffffff)`
                    : "#ffffff",
                  color: "#111827",
                  cursor: "pointer",
                  boxShadow: selected
                    ? "0 12px 26px rgba(15,23,42,.14)"
                    : "0 6px 16px rgba(15,23,42,.07)",
                  textAlign: "left"
                }}
              >
                <span
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: 13,
                    background: `linear-gradient(135deg, ${itemTheme.dark}, ${itemTheme.primary})`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 17,
                    color: "#fff",
                    flexShrink: 0,
                    boxShadow: `0 8px 18px ${itemTheme.primary}55`
                  }}
                >
                  {itemTheme.icon}
                </span>

                <span style={{ flex: 1, minWidth: 0 }}>
                  <span
                    style={{
                      display: "block",
                      fontSize: 12,
                      fontWeight: 950,
                      color: "#0b1d2d",
                      lineHeight: "18px"
                    }}
                  >
                    {itemTheme.name}
                  </span>

                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      marginTop: 5
                    }}
                  >
                    <span
                      style={{
                        width: 16,
                        height: 6,
                        borderRadius: 999,
                        background: itemTheme.primary,
                        display: "block"
                      }}
                    />
                    <span
                      style={{
                        width: 16,
                        height: 6,
                        borderRadius: 999,
                        background: itemTheme.dark,
                        display: "block"
                      }}
                    />
                    <span
                      style={{
                        width: 16,
                        height: 6,
                        borderRadius: 999,
                        background: itemTheme.bg,
                        display: "block",
                        border: "1px solid #e5e7eb"
                      }}
                    />
                  </span>
                </span>

                {selected && (
                  <span
                    className="theme-selected-dot"
                    style={{
                      width: 22,
                      height: 22,
                      borderRadius: "50%",
                      background: itemTheme.primary,
                      color: itemTheme.dark,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 950,
                      flexShrink: 0
                    }}
                  >
                    ✓
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    )}
  </div>
)}

           {/* ===== PREMIUM ALT SABİT BAR ===== */}
<div
  style={{
    position: "fixed",
    left: 12,
    right: 12,
    bottom: 12,
    zIndex: 600,
    height: 62,
    borderRadius: 24,
    background: "rgba(15,23,42,0.94)",
    border: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "0 18px 45px rgba(0,0,0,0.45)",
    backdropFilter: "blur(16px)",
    display: "grid",
    gridTemplateColumns: `repeat(${
      1 +
      (menuOptions.garson_cagir_active ? 1 : 0) +
      (menuOptions.siparis_active ? 1 : 0) +
      (canShowBillActions ? 1 : 0)
    }, minmax(0, 1fr))`,
    overflow: "hidden"
  }}
>
  <button
    type="button"
    onClick={() => {
      setShowCart(false);
      setShowBillModal(false);
      setActiveItem(null);
      setOpenSection(null);

      requestAnimationFrame(() => {
        menuTopRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        document.documentElement.scrollTo({
          top: 0,
          behavior: "smooth"
        });

        document.body.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });
    }}
    style={{
      border: "none",
      background: "transparent",
      color: "#fff",
      fontWeight: 900,
      fontSize: 12,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 3,
      cursor: "pointer"
    }}
  >
    <span style={{ fontSize: 22 }}>🍽️</span>
    {t("menuHome", lang)}
  </button>

  {menuOptions.garson_cagir_active && (
    <button
      type="button"
      onClick={() => {
        setShowCart(false);
        setShowBillModal(false);
        setShowWaiterModal(true);
      }}
      style={{
        border: "none",
        background: "transparent",
        color: "#fff",
        fontWeight: 900,
        fontSize: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        cursor: "pointer"
      }}
    >
      <span style={{ fontSize: 22 }}>🔔</span>
      Garson
    </button>
  )}







  {menuOptions.siparis_active && (
    <button
      type="button"
      onClick={() => {
        setShowBillModal(false);
        setShowCart(true);
      }}
      style={{
        border: "none",
        background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
        color: themeStyle.dark || "#0b1d2d",
        fontWeight: 950,
        fontSize: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        position: "relative",
        cursor: "pointer"
      }}
    >
      <span style={{ fontSize: 23 }}>🛒</span>
      {t("cart", lang)}

      {cart.length > 0 && (
        <span
          style={{
            position: "absolute",
            top: 7,
            right: "24%",
            minWidth: 19,
            height: 19,
            borderRadius: 999,
            background: "#fff",
            color: "#0b1d2d",
            fontSize: 11,
            fontWeight: 950,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 5px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.25)"
          }}
        >
          {cart.reduce((s, i) => s + Number(i.quantity || 0), 0)}
        </span>
      )}
    </button>
  )}

  {canShowBillActions && (
    <button
      type="button"
      onClick={() => {
        setShowCart(false);
        setShowBillModal(true);
      }}
      style={{
        border: "none",
        background: "transparent",
        color: "#fff",
        fontWeight: 900,
        fontSize: 12,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        cursor: "pointer"
      }}
    >
      <span style={{ fontSize: 22 }}>💳</span>
      {t("billPayShort", lang)}
    </button>
  )}
</div>

           {/* ===== PROFESYONEL SİSTEM BİLDİRİMİ ===== */}
      {appNotice && appNotice.position === "center" && (
        <div
          className="notice-center-backdrop"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 700,
            background: "rgba(15,23,42,.28)",
            backdropFilter: "blur(3px)",
            pointerEvents: "none"
          }}
        >
          <div
            className="notice-center-card"
            style={{
              position: "fixed",
              left: "50%",
              top: "50%",
              width: "calc(100% - 44px)",
              maxWidth: 360,
              background: "rgba(255,255,255,.97)",
              borderRadius: 30,
              padding: "28px 22px",
              textAlign: "center",
              boxShadow: "0 26px 70px rgba(15,23,42,.35)",
              border: "1px solid rgba(255,255,255,.8)"
            }}
          >
            <div
              className="notice-center-icon"
              style={{
                width: 86,
                height: 86,
                borderRadius: "50%",
                margin: "0 auto 16px",
                background:
                  appNotice.type === "success"
                    ? "linear-gradient(135deg, #22c55e, #16a34a)"
                    : appNotice.type === "warning"
                    ? "linear-gradient(135deg, #facc15, #f59e0b)"
                    : "linear-gradient(135deg, #ef4444, #dc2626)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: appNotice.icon === "✓" ? 48 : 38,
                fontWeight: 900
              }}
            >
              {appNotice.icon || (
                appNotice.type === "success"
                  ? "✓"
                  : appNotice.type === "warning"
                  ? "ℹ️"
                  : "!"
              )}
            </div>

            <div
              style={{
                fontSize: 21,
                fontWeight: 950,
                color: "#0b1d2d",
                marginBottom: 8
              }}
            >
              {appNotice.title}
            </div>

            <div
              style={{
                fontSize: 14,
                lineHeight: "21px",
                color: "#64748b",
                fontWeight: 700
              }}
            >
              {appNotice.text}
            </div>
          </div>
        </div>
      )}

      {appNotice && appNotice.position !== "center" && (
        <div
          className="waiter-toast"
          style={{
            position: "fixed",
            left: "50%",
            bottom: 96,
            zIndex: 500,
            width: "calc(100% - 32px)",
            maxWidth: 430,
            background: "rgba(255,255,255,.96)",
            backdropFilter: "blur(14px)",
            borderRadius: 24,
            padding: "14px 16px",
            boxShadow: "0 18px 45px rgba(15,23,42,.22)",
            border: "1px solid rgba(255,255,255,.75)",
            display: "flex",
            alignItems: "center",
            gap: 14
          }}
        >
          <div
            className="waiter-toast-icon"
            style={{
              width: 54,
              height: 54,
              borderRadius: "50%",
              background:
                appNotice.type === "success"
                  ? "linear-gradient(135deg, #ff9f1c, #ff7a00)"
                  : appNotice.type === "warning"
                  ? "linear-gradient(135deg, #facc15, #f59e0b)"
                  : "linear-gradient(135deg, #ef4444, #dc2626)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: 26,
              flexShrink: 0
            }}
          >
            {appNotice.icon || (
              appNotice.type === "success"
                ? "✓"
                : appNotice.type === "warning"
                ? "ℹ️"
                : "!"
            )}
          </div>

          <div style={{ flex: 1 }}>
            <div
              style={{
                fontSize: 16,
                fontWeight: 900,
                color: "#0b1d2d",
                marginBottom: 3
              }}
            >
              {appNotice.title}
            </div>

            <div
              style={{
                fontSize: 11,
                lineHeight: "18px",
                color: "#64748b",
                fontWeight: 600
              }}
            >
              {appNotice.text}
            </div>
          </div>
        </div>
      )}

  {/* ===== PROFESYONEL GARSON ÇAĞIRMA MODAL ===== */}
{showWaiterModal && (
  <div
    className="waiter-modal-backdrop-pro"
    onClick={() => setShowWaiterModal(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,42,.62)",
      backdropFilter: "blur(5px)",
      zIndex: 640,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 18
    }}
  >
    <div
      className="waiter-modal-card-pro"
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "100%",
        maxWidth: 340,
        background:
          "linear-gradient(180deg, rgba(255,255,255,.99), rgba(248,250,252,.98))",
        borderRadius: 28,
        padding: 18,
        boxShadow: "0 26px 70px rgba(15,23,42,.35)",
        border: "1px solid rgba(255,255,255,.85)",
        overflow: "hidden",
        position: "relative"
      }}
    >
      <div
        style={{
          position: "absolute",
          width: 150,
          height: 150,
          borderRadius: "50%",
          background: `${themeStyle.primary}24`,
          right: -60,
          top: -70
        }}
      />

      <div
        style={{
          textAlign: "center",
          position: "relative",
          zIndex: 2
        }}
      >
        <div
          className="waiter-bell-pro"
          style={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            margin: "0 auto 12px",
            background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
            color: themeStyle.dark,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 34,
            boxShadow: "0 14px 34px rgba(255,138,0,.32)"
          }}
        >
          🔔
        </div>

        <h2
          style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 950,
            color: "#0b1d2d"
          }}
        >
          {t("waiterTitle", lang)}
        </h2>

              <p
          style={{
            margin: "7px auto 16px",
            fontSize: 13,
            lineHeight: "19px",
            color: "#334155",
            fontWeight: 750,
            maxWidth: 280
          }}
        >
          Masa numaranızı veya adınızı yazın, ekibimiz kısa sürede yardımcı olsun.
        </p>
      </div>

      <div style={{ position: "relative", zIndex: 2 }}>
      <TextField
  label={
    qrTableNo
      ? `Masa / Oda · ${qrSalonName || "QR"}`
      : t("tableNo", lang)
  }

  fullWidth
  margin="normal"

 value={
  qrTableNo ||
  tableNo
}

onChange={(event) => {
  if (!qrTableNo) {
    setTableNo(
      event.target.value
    );
  }
}}

  type="text"

  readOnly={
    Boolean(qrTableNo)
  }
/>

        <TextField
          label={t("customerName", lang)}
          fullWidth
          margin="normal"
          value={waiterAd}
          onChange={(e) => setWaiterAd(e.target.value)}
        />

        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 16
          }}
        >
          <button
            onClick={() => setShowWaiterModal(false)}
            style={{
              flex: 1,
              padding: "11px 12px",
              borderRadius: 999,
              border: "1px solid #cbd5e1",
              background: "#fff",
              color: "#0b1d2d",
              fontWeight: 850,
              cursor: "pointer"
            }}
          >
            {t("cancel", lang)}
          </button>

          <button
            onClick={callWaiter}
            style={{
              flex: 1,
              padding: "11px 12px",
              borderRadius: 999,
              border: "none",
              background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
              color: themeStyle.dark,
              fontWeight: 950,
              cursor: "pointer",
              boxShadow: "0 10px 24px rgba(255,138,0,.28)"
            }}
          >
            {t("call", lang)}
          </button>
        </div>
      </div>
    </div>
  </div>
)}

      {/* ===== HEADER ===== */}
      <header
        style={{
          background:
            `radial-gradient(circle at 50% 0%, ${themeStyle.primary}30, transparent 34%),
             linear-gradient(180deg, ${themeStyle.dark} 0%, #071421 68%, ${themeStyle.primary} 150%)`,
          padding: "26px 16px 22px",
          color: "#fff",
          textAlign: "center",
          borderBottom: "1px solid rgba(255,255,255,0.10)",
          boxShadow: "0 14px 38px rgba(0,0,0,0.28)",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 220,
            height: 220,
            borderRadius: "50%",
            background: `${themeStyle.primary}22`,
            filter: "blur(34px)",
            left: "50%",
            top: -120,
            transform: "translateX(-50%)",
            pointerEvents: "none"
          }}
        />

        <div style={{ maxWidth: 760, margin: "0 auto", position: "relative", zIndex: 2 }}>
          <div
            className="hero-logo-pro"
            style={{
              width: 52,
              height: 52,
              borderRadius: 19,
              margin: "0 auto 10px",
              background: "linear-gradient(145deg, rgba(255,255,255,.18), rgba(255,255,255,.06))",
              border: "1px solid rgba(255,255,255,0.22)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 27,
              boxShadow: `0 14px 32px rgba(0,0,0,.30), 0 0 28px ${themeStyle.primary}22`,
              backdropFilter: "blur(12px)"
            }}
          >
            🍽️
          </div>

          <h1
            className="hero-title-pro"
            style={{
              fontSize: "clamp(24px,5vw,34px)",
              fontWeight: 950,
              margin: 0,
              letterSpacing: "-0.8px",
              lineHeight: 1.05
            }}
          >
            {contact.kurum_adi}
          </h1>

          <div
            style={{
              marginTop: 6,
              color: "rgba(255,255,255,0.70)",
              fontWeight: 750,
              fontSize: 13
            }}
          >
            {t("welcome", lang)}
          </div>

          <div
            style={{
              marginTop: 12,
              display: "flex",
              justifyContent: "center",
              gap: 8,
              flexWrap: "wrap"
            }}
          >
            {menuLangs.map(l => (
              <button
                key={l}
                onClick={() => setLang(l)}
                style={{
                  padding: "8px 17px",
                  borderRadius: 999,
                  fontWeight: 950,
                  border: l === lang
                    ? `1px solid ${themeStyle.primary}`
                    : "1px solid rgba(255,255,255,0.24)",
                  background: l === lang
                    ? themeStyle.primary
                    : "rgba(255,255,255,0.09)",
                  color: l === lang ? themeStyle.dark : "#fff",
                  boxShadow: l === lang
                    ? `0 10px 24px ${themeStyle.primary}48`
                    : "none",
                  cursor: "pointer"
                }}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>

          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder={TEXT.search[lang]}
            style={{
              marginTop: 16,
              width: "100%",
              maxWidth: 480,
              padding: "15px 18px",
              borderRadius: 22,
              border: "1px solid rgba(255,255,255,0.20)",
              background: "rgba(255,255,255,0.97)",
              color: "#0b1d2d",
              fontSize: 15,
              fontWeight: 800,
              outline: "none",
              boxShadow: "0 14px 34px rgba(0,0,0,0.24)"
            }}
          />
        </div>
      </header>




{/* ===== TREND ÜRÜNLER / MENÜ VİTRİNİ ===== */}
{hasUpperSlider && (
  <section
    style={{
      padding: "20px 12px 6px",
    }}
  >
    <div
      style={{
        textAlign: "center",
        marginBottom: 10,
      }}
    >
      <h2
        style={{
          fontSize:
            "clamp(22px, 5vw, 28px)",
          fontWeight: 800,
          margin: 0,
          marginBottom: 6,
          color: sectionTitleColor,
        }}
      >
        {useMenuShowcase
          ? `🏨 ${TEXT.showcase[lang]}`
          : `⭐ ${TEXT.trends[lang]}`}
      </h2>

      <div
        style={{
          width: 60,
          height: 4,
          margin: "0 auto",
          borderRadius: 4,
          background:
            themeStyle.primary,
        }}
      />
    </div>

    <div
      ref={sliderRef}
      style={{
        display: "flex",
        gap: 16,
        overflowX: "auto",
        scrollBehavior: "smooth",
        paddingBottom: 12,
      }}
      onTouchStart={() => {
        if (autoRef.current) {
          clearInterval(
            autoRef.current
          );

          autoRef.current = null;
        }
      }}
    >
      {useMenuShowcase
        ? showcaseSections.map(
            (section) => {
              const sectionItemCount = (
                section.categories || []
              ).reduce(
                (total, category) =>
                  total +
                  (category.items
                    ?.length || 0),
                0
              );

              const firstCategory =
                section.categories?.[0] ||
                null;

              const isSelected =
                String(
                  activeShowcaseSection
                    ?.category_key || ""
                ) ===
                String(
                  section.category_key ||
                    ""
                );

              const selectShowcaseSection =
                () => {
                  setActiveShowcaseKey(
                    section.category_key
                  );

                  // ✅ Önceki vitrinde açık kalan kategori kapanır.
                  setOpenSection(null);
                  setOpenItem(null);

                  // ✅ Önceki vitrinde yapılan arama yeni vitrini gizlemesin.
                  setSearch("");
                };

              return (
                <div
                  key={section.id}
                  onClick={
                    selectShowcaseSection
                  }
                  style={{
                    minWidth: 224,
                    background:
                      softCardBg,
                    borderRadius: 22,
                    cursor: "pointer",

                    boxShadow:
                      isSelected
                        ? `0 18px 42px ${themeStyle.primary}55`
                        : "0 16px 38px rgba(0,0,0,.32)",

                    overflow: "hidden",

                    border:
                      isSelected
                        ? `3px solid ${themeStyle.primary}`
                        : "1px solid rgba(255,255,255,0.28)",

                    transform:
                      isSelected
                        ? "translateY(-2px)"
                        : "translateY(0)",

                    transition:
                      "border-color .2s ease, box-shadow .2s ease, transform .2s ease",
                  }}
                >
                  <div
                    style={{
                      position:
                        "relative",
                      height: 148,
                      overflow:
                        "hidden",
                    }}
                  >
                    <img
                      src={resolveCategoryImage(
                        firstCategory,
                        section
                      )}
                      alt={
                        section.title
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit:
                          "cover",
                        objectPosition:
                          "center",
                        display:
                          "block",
                        filter:
                          "brightness(.82) saturate(1.08)",
                      }}
                      onError={(e) => {
                        e.currentTarget.src =
                          `${IMAGE_BASE}/default.jpg`;
                      }}
                    />

                    <div
                      style={{
                        position:
                          "absolute",
                        inset: 0,
                        background:
                          "linear-gradient(180deg, transparent 30%, rgba(0,0,0,.72) 100%)",
                      }}
                    />

                    {isSelected && (
                      <div
                        style={{
                          position:
                            "absolute",
                          top: 10,
                          right: 10,
                          width: 30,
                          height: 30,
                          borderRadius:
                            "50%",
                          background:
                            themeStyle.primary,
                          color:
                            themeStyle.dark,
                          display: "flex",
                          alignItems:
                            "center",
                          justifyContent:
                            "center",
                          fontSize: 16,
                          fontWeight: 950,
                          boxShadow:
                            "0 8px 18px rgba(0,0,0,.28)",
                        }}
                      >
                        ✓
                      </div>
                    )}

                    <div
                      style={{
                        position:
                          "absolute",
                        left: 12,
                        right: 12,
                        bottom: 12,
                        color: "#fff",
                        fontWeight: 950,
                        fontSize: 17,
                        lineHeight:
                          "21px",
                        textShadow:
                          "0 3px 12px rgba(0,0,0,.65)",
                      }}
                    >
                      {section.title}
                    </div>
                  </div>

                  <div
                    style={{
                      padding: 12,
                    }}
                  >
                    <div
                      style={{
                        color:
                          "#475569",
                        fontWeight: 850,
                        fontSize: 12,
                      }}
                    >
                      {sectionItemCount}{" "}
                      {
                        TEXT
                          .showcaseItems[
                          lang
                        ]
                      }
                    </div>

                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();

                        selectShowcaseSection();
                      }}
                      style={{
                        marginTop: 10,

                        background:
                          isSelected
                            ? themeStyle.primary
                            : themeStyle.dark,

                        color:
                          isSelected
                            ? themeStyle.dark
                            : "#fff",

                        border: "none",
                        borderRadius: 30,
                        padding:
                          "9px 12px",
                        fontSize: 12,
                        fontWeight: 900,
                        cursor:
                          "pointer",
                        width: "100%",
                      }}
                    >
                      {isSelected
                        ? "✓ "
                        : ""}

                      {section.title} →
                    </button>
                  </div>
                </div>
              );
            }
          )
        : trendItems.map(
            (item) => {
              const priceOptions =
                normalizePublicPriceOptions(
                  item.price_options
                );

              return (
                <div
                  key={item.id}
                  onClick={() =>
                    setActiveItem(
                      item
                    )
                  }
                  style={{
                    minWidth: 224,
                    background:
                      softCardBg,
                    borderRadius: 22,
                    cursor: "pointer",
                    boxShadow:
                      "0 16px 38px rgba(0,0,0,.32)",
                    overflow:
                      "hidden",
                    border:
                      "1px solid rgba(255,255,255,0.28)",
                  }}
                >
                  <div
                    style={{
                      overflow:
                        "hidden",
                      borderTopLeftRadius: 18,
                      borderTopRightRadius: 18,
                    }}
                  >
                    <img
                      src={
                        item.image ||
                        `${IMAGE_BASE}/default.jpg`
                      }
                      alt={item.title}
                      style={{
                        width: "100%",
                        height: 148,
                        objectFit:
                          "cover",
                        objectPosition:
                          "center",
                        display:
                          "block",
                      }}
                      onError={(e) => {
                        e.currentTarget.src =
                          `${IMAGE_BASE}/default.jpg`;
                      }}
                    />
                  </div>

                  <div
                    style={{
                      padding: 12,
                    }}
                  >
                    <strong
                      style={{
                        fontSize: 16.5,
                        lineHeight:
                          "21px",
                        fontWeight: 950,
                        color:
                          "#0f172a",
                        letterSpacing:
                          "-.25px",
                        minHeight: 0,
                        display:
                          "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient:
                          "vertical",
                        overflow:
                          "hidden",
                      }}
                    >
                      {item.title}
                    </strong>

                    <div
                      style={{
                        color:
                          themeStyle.primary,
                        fontWeight: 950,
                        fontSize: 16,
                        marginTop: 6,
                      }}
                    >
                      {getPublicTrendPriceText(
                        item
                      )}
                    </div>

                    {menuOptions.siparis_active && (
                      <>
                        {priceOptions.length >
                          1 && (
                          <button
                            type="button"
                            onClick={(
                              e
                            ) => {
                              e.stopPropagation();

                              setActiveItem(
                                item
                              );
                            }}
                            style={{
                              marginTop: 10,
                              background:
                                themeStyle.dark,
                              color:
                                "#fff",
                              border:
                                "none",
                              borderRadius: 30,
                              padding:
                                "8px 12px",
                              fontSize: 12,
                              fontWeight: 900,
                              cursor:
                                "pointer",
                              width:
                                "100%",
                              boxShadow:
                                "0 8px 18px rgba(15,23,42,.18)",
                            }}
                          >
                            Seçenekleri Gör
                          </button>
                        )}

                        {priceOptions.length <=
                          1 && (
                          <button
                            type="button"
                            onClick={(
                              e
                            ) => {
                              e.stopPropagation();

                              addToCart(
                                item
                              );
                            }}
                            style={{
                              marginTop: 10,
                              background:
                                themeStyle.dark,
                              color:
                                "#fff",
                              border:
                                "none",
                              borderRadius: 30,
                              padding:
                                "8px 12px",
                              fontSize: 12,
                              fontWeight: 900,
                              cursor:
                                "pointer",
                              width:
                                "100%",
                            }}
                          >
                            {
                              TEXT
                                .addToCart[
                                lang
                              ]
                            }
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              );
            }
          )}
    </div>
  </section>
)}

{/* ===== KATEGORİ GEÇİŞ BAŞLIĞI ===== */}
<section
  style={{
    marginTop: 6,
    marginBottom: 4,
    padding: "10px 16px 8px",
    textAlign: "center",
    background: "transparent",
  }}
>
  <h2
    style={{
      fontSize: "clamp(20px, 4vw, 25px)",
      fontWeight: 950,
      margin: 0,
      color: sectionTitleColor,
      letterSpacing: "-0.4px",
    }}
  >
    {useMenuShowcase && activeShowcaseSection
      ? activeShowcaseSection.title
      : TEXT.categories[lang]}
  </h2>

  <div
    style={{
      fontSize: 12,
      color: sectionSubColor,
      marginTop: 4,
      marginBottom: 8,
      fontWeight: 650,
    }}
  >
    {useMenuShowcase && activeShowcaseSection
      ? `${activeShowcaseSection.title} • ${TEXT.categoriesSub[lang]}`
      : TEXT.categoriesSub[lang]}
  </div>

  <div
    style={{
      width: 60,
      height: 4,
      margin: "0 auto",
      borderRadius: 4,
      background: themeStyle.primary,
      boxShadow: `0 6px 16px ${themeStyle.primary}66`,
    }}
  />
</section>


{/* ===== KATEGORİLER (PREMIUM KOMPAKT GÖRSELLİ) ===== */}
<div
  style={{
    maxWidth: 1200,
    margin: "0 auto",
    padding: "12px 11px 28px",
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: 12,
    alignItems: "start"
  }}
>

  {filteredSections.map(sec =>
    sec.categories.map(cat => {
      const isOpen = openSection === cat.id;

      return (
       

        <div
          key={cat.id}
          ref={(el) => {
            categoryRefs.current[cat.id] = el;
          }}
        className="menu-category-card-pro"
style={{
  gridColumn: isOpen ? "1 / -1" : "auto",
  marginBottom: 0,
  borderRadius: 16,
  overflow: "hidden",
  background: isOpen ? "rgba(255,255,255,0.96)" : softPanelBg,
  boxShadow: isOpen
    ? "0 20px 48px rgba(0,0,0,.34)"
    : "0 12px 28px rgba(0,0,0,.26)",
  border: isOpen ? "1px solid rgba(255,255,255,0.38)" : `1px solid ${softPanelBorder}`,
  scrollMarginTop: 12
}}
        >


          {/* === KATEGORİ KARTI === */}
          <div
                       onClick={() => {
              const nextId = isOpen ? null : cat.id;

              setOpenSection(nextId);

              if (nextId) {
                setTimeout(() => {
                  categoryRefs.current[nextId]?.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  });
                }, 100);
              }
            }}
                         style={{
              position: "relative",
              height: isOpen ? 150 : 124,
              cursor: "pointer",
              overflow: "hidden"
            }}
          >
<div style={{ 
  position: "absolute", 
  inset: 0,
  overflow: "hidden"  // 🔥 TAŞMAYI KESER
}}>
  <img
    src={resolveCategoryImage(cat, sec)}
    onError={e => (e.currentTarget.src = `${IMAGE_BASE}/default.jpg`)}
    alt={cat.title}
       style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      filter: "brightness(.82) saturate(1.12) contrast(1.04)",
      display: "block",
      transform: "scale(1.01)"
    }}
  />
</div>

<div
  className="category-title-pro"
  style={{
    position: "absolute",
    left: 8,
    right: 8,
    bottom: 8,
    color: "#fff",
    fontSize: 14,
    fontWeight: 950,
    lineHeight: "17px",
    padding: "8px 10px",
    borderRadius: 13,
    background: "linear-gradient(90deg, rgba(0,0,0,.74), rgba(0,0,0,.32))",
    backdropFilter: "blur(6px)",
    textShadow: "0 2px 8px rgba(0,0,0,.60)",
    boxShadow: "0 8px 20px rgba(0,0,0,.22)"
  }}
>
  {cat.title}
</div>
          </div>

          {/* === ALT ÜRÜNLER === */}
          {isOpen && (
            <div
           style={{
  padding: 12,
  display: "flex",
  flexDirection: "column",
  gap: 10
}}
            >
         
{cat.items.map((item, index) => (
  <div
    key={item.id}
    className="menu-product-card"
    onClick={() => setActiveItem(item)}
style={{
  background: "#ffffff",
  borderRadius: 20,
  overflow: "hidden",
  cursor: "pointer",
  boxShadow: "0 10px 24px rgba(15,23,42,.08)",
  border: "1px solid #e5e7eb",
  display: "grid",
gridTemplateColumns: "112px minmax(0, 1fr)",
  gap: 12,
  padding: 12,
  alignItems: "stretch",
  direction: "ltr",
animationDelay: `${index * 55}ms`
}}
  >
    <div
     style={{
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gridColumn: "2",
  gridRow: "1"
}}
    >
    <strong
  style={{
    fontSize: 16.5,
    lineHeight: "21px",
    fontWeight: 950,
    color: "#0f172a",
    letterSpacing: "-.25px",
    minHeight: 0,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
  }}
>
  {item.title}
</strong>

   <div
  style={{
    color: themeStyle.primary || "#ff8a00",
    fontWeight: 950,
    marginTop: 5,
    fontSize: 15.5,
    lineHeight: "20px",
    letterSpacing: "-.15px"
  }}
>
  {getPublicItemPriceText(item)}
</div>

      {hasPublicPriceOptions(item) && (
        <div
          style={{
            marginTop: 8,
            padding: "8px 0",
            borderTop: "1px solid #f1f5f9",
            borderBottom: "1px solid #f1f5f9"
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 950,
              color: "#94a3b8",
              letterSpacing: .4,
              textTransform: "uppercase",
              marginBottom: 5
            }}
          >
            Seçenekler
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 4 }}>
            {normalizePublicPriceOptions(item.price_options).slice(0, 5).map((opt) => (
              <div
                key={opt.id}
                style={{
                  minWidth: 0,
                  display: "grid",
                  gridTemplateColumns: "8px minmax(0, 1fr)",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 11,
                  lineHeight: "14px",
                  fontWeight: 800,
                  color: "#334155"
                }}
              >
                <span
                  style={{
                    width: 5,
                    height: 5,
                    borderRadius: "50%",
background: "#94a3b8",
                    display: "block"
                  }}
                />
                <span
                  style={{
                    minWidth: 0,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {opt.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

<div
  style={{
    fontSize: 12.8,
    color: "#64748b",
    marginTop: 7,
    lineHeight: "18px",
    fontWeight: 650,
    minHeight: 0,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden"
  }}
>
  {item.description || ""}
</div>

      <PublicComplianceBox
        item={item}
        lang={lang}
        themeStyle={themeStyle}
        compact
      />

      {menuOptions.siparis_active && !hasPublicPriceOptions(item) && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            addToCart(item);
          }}
      style={{
  marginTop: "auto",
  background: "linear-gradient(135deg, #ff9f1c 0%, #ff7a00 100%)",
  border: "none",
  borderRadius: 999,
  padding: "10px 12px",
  fontWeight: 950,
  cursor: "pointer",
  width: "100%",
  color: "#0b1d2d",
  fontSize: 14,
  lineHeight: "17px",
  letterSpacing: "-.1px",
  boxShadow: "0 8px 18px rgba(255,138,0,.30)"
}}
        >
          {TEXT.addToCart[lang]}
        </button>
      )}
    </div>

    <div
      className="menu-product-img"
    style={{
  width: 112,
  height: 112,
  borderRadius: 18,
  overflow: "hidden",
  background: "#f8fafc",
  alignSelf: "center",
justifySelf: "start",  gridColumn: "1",
  gridRow: "1",
  boxShadow: "inset 0 0 0 1px #edf2f7"
}}
    >
      <img
        src={item.image || `${IMAGE_BASE}/default.jpg`}
        alt={item.title}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
          display: "block"
        }}
        onError={(e) => {
          e.currentTarget.src = `${IMAGE_BASE}/default.jpg`;
        }}
      />
    </div>
  </div>
))}




            </div>
          )}
        </div>
      );
    })
  )}
</div>

{/* ⭐ GOOGLE YORUM */}
{googleReview?.google_review_active &&
 googleReview?.google_review_url && (

<section
style={{
padding:"20px 14px",
maxWidth:420,
margin:"10px auto 24px",
}}
>

<div
style={{
background:"rgba(255,255,255,0.94)",
borderRadius:24,
padding:24,
textAlign:"center",
boxShadow:"0 18px 45px rgba(0,0,0,.34)",
border:"1px solid rgba(255,255,255,0.45)",
backdropFilter:"blur(14px)"
}}
>

<div style={{fontSize:36}}>
⭐
</div>

<h2
style={{
color:"#0b1d2d",
fontWeight:800
}}
>
{
googleReview.google_review_title_json?.[lang] ||
"Review us on Google"
}
</h2>


<p
style={{
color:"#666",
fontSize:15
}}
>
{
googleReview.google_review_desc_json?.[lang] ||
"Share your experience"
}
</p>


<a
href={googleReview.google_review_url}
target="_blank"
rel="noreferrer"
style={{
display:"inline-block",
marginTop:12,
background:"#ff8a00",
color:"#0b1d2d",
padding:"12px 24px",
borderRadius:999,
fontWeight:800,
textDecoration:"none"
}}
>

{lang==="de"
?"Auf Google bewerten"
:lang==="en"
?"Review on Google"
:"Google’da Yorum Yap"}

</a>

</div>

</section>

)}

         {/* FOOTER */}
     <footer
  style={{
    background: "rgba(2,6,23,0.72)",
    padding: "34px 16px 34px",
    color: "#fff",
    borderTop: "1px solid rgba(255,255,255,0.08)"
  }}
>
  {/* TURUNCU KART */}
  <div
    style={{
       background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
      borderRadius: 22,
      padding: "22px 20px",
      maxWidth: 420,
      margin: "0 auto 28px",
      color: themeStyle.dark || "#0b1d2d",
      boxShadow: "0 16px 38px rgba(0,0,0,.38)",
      textAlign: "center",    
    }}
  >

    <div
      style={{
        fontSize: 20,
        fontWeight: 700,
        marginBottom: 6
      }}
    >
      {TEXT.thanks[lang]}
    </div>

  
    {/* SOSYAL ICONLAR */}
    <div
      style={{
        display: "flex",
        gap: 12,
        justifyContent: "center"
      }}
    >
     {contact.instagram && <MiniIcon href={contact.instagram} type="instagram" />}
{contact.youtube && <MiniIcon href={contact.youtube} type="youtube" />}
{contact.facebook && <MiniIcon href={contact.facebook} type="facebook" />}
{contact.website && <MiniIcon href={contact.website} type="web" />}
    </div>
  </div>

{/* ALT BİLGİ - FİRMA BAZLI İLETİŞİM */}
<div
  style={{
    textAlign: "center",
    fontSize: 14,
    color: "#c7d0d9",
    lineHeight: "24px",
    maxWidth: 520,
    margin: "0 auto"
  }}
>
{(contact.adres || contact.adres_tr || contact.address) && (
  <div style={{ whiteSpace: "pre-line", marginBottom: 6 }}>
    📍 {contact.adres || contact.adres_tr || contact.address}
  </div>
)}

{(contact.saat || contact.saat_tr || contact.calisma_saati) && (
  <div style={{ whiteSpace: "pre-line", marginBottom: 6 }}>
    🕒 {contact.saat || contact.saat_tr || contact.calisma_saati}
  </div>
)}


{contact.telefon && (
  <div style={{ marginBottom: 6 }}>
    📞 <a
      href={`tel:${contact.telefon}`}
      style={{ color: "#c7d0d9", textDecoration: "none" }}
    >
      {contact.telefon}
    </a>
  </div>
)}
  {contact.whatsapp && (
    <div style={{ marginBottom: 6 }}>
      💬 <a
        href={`https://wa.me/${contact.whatsapp.replace(/\D/g, "")}`}
        target="_blank"
        rel="noreferrer"
        style={{ color: "#c7d0d9", textDecoration: "none" }}
      >
        WhatsApp
      </a>
    </div>
  )}

  {contact.harita_url && (
    <div style={{ marginTop: 10 }}>
      <a
        href={contact.harita_url}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "inline-block",
          padding: "8px 16px",
          borderRadius: 999,
        background: themeStyle.primary,
color: themeStyle.dark,
          fontWeight: 800,
          textDecoration: "none"
        }}
      >
        Konuma Git
      </a>
    </div>
  )}
</div>

    </footer>

      {/* ===== MODAL ===== */}
      {activeItem && (
        <div
          onClick={() => setActiveItem(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.65)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 20,
              maxWidth: 420,
              width: "90%",
              overflow: "hidden"
            }}
          >

<ProductImageBox
  src={activeItem.image}
  alt={activeItem.title}
  height={280}
/>

<div style={{ padding: 18 }}>
  <h2
    style={{
      margin: "0 0 8px",
      color: "#0f172a",
      fontSize: 23,
      lineHeight: "28px",
      fontWeight: 950,
      letterSpacing: "-.35px"
    }}
  >
    {activeItem.title}
  </h2>

  <div
    style={{
      color: themeStyle.primary || "#ff8a00",
      fontWeight: 950,
      fontSize: 19,
      lineHeight: "24px",
      letterSpacing: "-.2px"
    }}
  >
    {getPublicItemPriceText(activeItem)}
  </div>

{menuOptions.siparis_active && hasPublicPriceOptions(activeItem) && (
  <div
    style={{
      display: "grid",
      gap: 8,
      marginTop: 12,
      marginBottom: 12
    }}
  >
    {normalizePublicPriceOptions(activeItem.price_options).map((opt) => (
      <button
        key={opt.id}
        onClick={() => {
          addToCart(activeItem, opt);
          setActiveItem(null);
        }}
        style={{
          background: "linear-gradient(135deg, #ff9f1c 0%, #ff7a00 100%)",
          border: "none",
          borderRadius: 18,
          padding: "12px 14px",
          fontWeight: 950,
          cursor: "pointer",
          width: "100%",
          color: "#0b1d2d",
          fontSize: 14,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
          boxShadow: "0 8px 18px rgba(255,138,0,.25)"
        }}
      >
        <span>{opt.label}</span>
        <span>{moneyText(opt.price, opt.currency)}</span>
      </button>
    ))}
  </div>
)}

{activeItem.description && (
  <p
   style={{
  color: "#475569",
  lineHeight: "22px",
  fontSize: 15,
  fontWeight: 650,
  marginTop: 12,
  marginBottom: 0,
}}
  >
    {activeItem.description}
  </p>
)}

<PublicComplianceBox
  item={activeItem}
  lang={lang}
  themeStyle={themeStyle}
/>

              {/* ✅ EKLENDI: Modal içine de sepete ekle butonu */}


{menuOptions.siparis_active &&
  !hasPublicPriceOptions(activeItem) && (
    <button
      onClick={() => {
        addToCart(activeItem);
        setActiveItem(null);
      }}
    style={{
  marginTop: 14,
  background: "linear-gradient(135deg, #1565C0 0%, #0d47a1 100%)",
  border: "none",
  borderRadius: 999,
  padding: "13px 20px",
  fontWeight: 950,
  cursor: "pointer",
  width: "100%",
  color: "#fff",
  fontSize: 15,
  lineHeight: "19px",
  letterSpacing: "-.1px",
  boxShadow: "0 10px 22px rgba(21,101,192,.28)"
}}
    >
      {TEXT.addToCart[lang]}
    </button>
)}
            </div>
          </div>
        </div>
      )}



{canShowBillActions && showBillModal && (
  <div
    className="cart-backdrop-pro"
    onClick={() => setShowBillModal(false)}
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      background: "rgba(2, 6, 23, 0.58)",
      backdropFilter: "blur(10px)",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "100%",
        maxWidth: 520,
        maxHeight: "92vh",
        overflowY: "auto",
        background: "#f8fafc",
        borderRadius: "30px 30px 0 0",
        padding: 18,
        boxShadow: "0 -20px 60px rgba(15,23,42,.35)",
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #0f172a, #f97316)",
          borderRadius: 24,
          padding: 18,
          color: "#fff",
          marginBottom: 14,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
          <div>
            <div
              style={{
                fontSize: 12,
                fontWeight: 900,
                opacity: 0.85,
                letterSpacing: 0.8,
              }}
            >
              MASA HESABI
            </div>

            <h2
              style={{
                margin: "6px 0 0",
                fontSize: 23,
                lineHeight: "28px",
                fontWeight: 950,
              }}
            >
              💳 Hesabımı Gör / Öde
            </h2>

            <p
              style={{
                margin: "10px 0 0",
                fontSize: 13,
                lineHeight: "19px",
                fontWeight: 650,
                color: "rgba(255,255,255,.82)",
              }}
            >
              Masa hesabınızı canlı görün, tamamını ödeyin veya kendi payınızı seçin.
            </p>
          </div>

          <button
            onClick={() => setShowBillModal(false)}
            style={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,.35)",
              background: "rgba(255,255,255,.16)",
              color: "#fff",
              fontSize: 18,
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            ✕
          </button>
        </div>
      </div>

      <div
        style={{
          background: "#fff",
          border: "1px solid #e2e8f0",
          borderRadius: 22,
          padding: 14,
          marginBottom: 12,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 10,
          }}
        >
<input
  value={
    qrTableNo ||
    billTableNo
  }

  onChange={(event) => {
    if (!qrTableNo) {
      setBillTableNo(
        event.target.value
      );
    }
  }}

  readOnly={
    Boolean(qrTableNo)
  }

  placeholder="Masa / Oda"
  inputMode="text"
  autoComplete="off"

  style={{
    width: "100%",

    border:
      "1px solid #cbd5e1",

    borderRadius: 14,

    padding:
      "12px 13px",

    fontWeight: 850,

    outline: "none",

    background:
      qrTableNo
        ? "#F8FAFC"
        : "#FFFFFF",

    color: "#0f172a",

    WebkitTextFillColor:
      "#0f172a",

    caretColor:
      qrTableNo
        ? "transparent"
        : "#f97316",

    cursor:
      qrTableNo
        ? "not-allowed"
        : "text",

    opacity: 1,
    fontSize: 15,
  }}
/>

<input
  value={billCustomerName}
  onChange={(e) => setBillCustomerName(e.target.value)}
  placeholder="Adınız"
  inputMode="text"
  autoComplete="name"
  style={{
    width: "100%",
    border: "1px solid #cbd5e1",
    borderRadius: 14,
    padding: "12px 13px",
    fontWeight: 850,
    outline: "none",

    // ✅ MOBİLDE GÖRÜNMEYEN YAZIYI DÜZELTİR
    background: "#ffffff",
    color: "#0f172a",
    WebkitTextFillColor: "#0f172a",
    caretColor: "#f97316",
    opacity: 1,
    fontSize: 15,
  }}
/>
        </div>

        <button
          type="button"
          disabled={billLoading}
          onClick={() => loadTableBill()}
          style={{
            marginTop: 10,
            width: "100%",
            border: 0,
            borderRadius: 16,
            padding: "13px 14px",
            background: billLoading
              ? "#94a3b8"
              : "linear-gradient(135deg, #0f172a, #2563eb)",
            color: "#fff",
            fontWeight: 950,
            cursor: billLoading ? "not-allowed" : "pointer",
          }}
        >
          {billLoading ? "Hesap getiriliyor..." : "Masa Hesabını Getir"}
        </button>
      </div>

      {tableBillData && (
        <>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: 8,
              marginBottom: 12,
            }}
          >
            <div
              style={{
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 18,
                padding: 10,
              }}
            >
              <div style={{ fontSize: 11, color: "#64748b", fontWeight: 800 }}>
                Toplam
              </div>
             

<div
  style={{
    marginTop: 4,
    minHeight: 20,

    fontSize: 14,
    fontWeight: 950,

    color: "#0f172a",

    whiteSpace:
      "nowrap",
  }}
>
  {moneyText(
    tableBillData.total_amount,
    tableBillData.currency
  )}
</div>


            </div>

            <div
              style={{
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 18,
                padding: 10,
              }}
            >
              <div style={{ fontSize: 11, color: "#64748b", fontWeight: 800 }}>
                Ödenen
              </div>
              <div style={{ fontSize: 14, fontWeight: 950, color: "#16a34a" }}>
                {moneyText(tableBillData.paid_amount, tableBillData.currency)}
              </div>
            </div>

            <div
              style={{
                background: "#fff7ed",
                border: "1px solid #fed7aa",
                borderRadius: 18,
                padding: 10,
              }}
            >
              <div style={{ fontSize: 11, color: "#9a3412", fontWeight: 800 }}>
                Kalan
              </div>
              <div style={{ fontSize: 14, fontWeight: 950, color: "#9a3412" }}>
                {moneyText(tableBillData.remaining_amount, tableBillData.currency)}
              </div>
            </div>
          </div>

          <div style={{ display: "grid", gap: 9, marginBottom: 12 }}>
          


 {[
  [
    "full",
    "🟢",
    "Hesabın Tamamını Öde",

    `Ödenecek: ${moneyText(
      tableBillData.remaining_amount,
      tableBillData.currency
    )}`,
  ],

  [
    "items",
    "☑️",
    "Ürün Seçerek Öde",

    billSelectedItems.length > 0
      ? `${billSelectedItems.length} ürün seçildi`
      : "Sadece kendi ürünlerini seç",
  ],

  [
    "amount",
    "✍️",
    "Tutar Girerek Öde",

    billNumber(
      billAmount
    ) > 0
      ? `Ödenecek: ${moneyText(
          billAmount,
          tableBillData.currency
        )}`
      : "Belirli bir tutar gir",
  ],

  [
    "people",
    "👥",
    "Kişi Sayısına Böl",

    Number(
      billPeopleCount ||
        0
    ) > 0
      ? `${Number(
          billPeopleCount
        )} kişi · Kişi başı ${moneyText(
          billNumber(
            tableBillData.remaining_amount
          ) /
            Number(
              billPeopleCount
            ),

          tableBillData.currency
        )}`
      : "Kişi sayısını girince kişi başı tutar görünür",
  ],
].map(
  ([
    mode,
    icon,
    title,
    desc,
  ]) => (



              <button
                key={mode}
                type="button"
                onClick={() => setBillMode(mode)}
                style={{
                  border:
                    billMode === mode
                      ? "2px solid #f97316"
                      : "1px solid #e2e8f0",
                  background: billMode === mode ? "#fff7ed" : "#fff",
                  color: "#0f172a",
                  borderRadius: 19,
                  padding: "13px 14px",
                  display: "grid",
                  gridTemplateColumns: "38px 1fr",
                  gap: 11,
                  alignItems: "center",
                  textAlign: "left",
                  cursor: "pointer",
                }}
              >
                <span style={{ fontSize: 25 }}>{icon}</span>
                

<span
  style={{
    minWidth: 0,
    color: "#0f172a",
  }}
>
  <strong
    style={{
      display: "block",

      fontSize: 14,
      lineHeight: "19px",

      color: "#0f172a",
    }}
  >
    {title}
  </strong>

  <small
    style={{
      display: "block",

      marginTop: 3,

      color: "#475569",

      fontSize: 11.5,
      fontWeight: 800,
      lineHeight: "16px",

      whiteSpace: "normal",
    }}
  >
    {desc}
  </small>
</span>



              </button>
            ))}
          </div>




          {billMode === "items" && (
            <div
              style={{
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 20,
                padding: 12,
                marginBottom: 12,
              }}
            >
              <div
                style={{
                  fontWeight: 950,
                  fontSize: 14,
                  marginBottom: 8,
                  color: "#0f172a",
                }}
              >
                Kendi ürünlerini seç
              </div>

              <div style={{ display: "grid", gap: 8 }}>
                {(tableBillData.items || []).map((item) => {
                  const checked = billSelectedItems.includes(item.line_uid);

                  return (
                    <label
                      key={item.line_uid}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "24px 1fr auto",
                        alignItems: "center",
                        gap: 8,
                        border: checked
                          ? "1px solid #fb923c"
                          : "1px solid #e2e8f0",
                        background: checked ? "#fff7ed" : "#f8fafc",
                        borderRadius: 14,
                        padding: 10,
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => toggleBillItem(item.line_uid)}
                      />

                      <span style={{ minWidth: 0 }}>
                        <b style={{ fontSize: 13 }}>{item.title}</b>
                        <div
                          style={{
                            fontSize: 11,
                            color: "#64748b",
                            fontWeight: 700,
                          }}
                        >
                          {item.quantity} x {moneyText(item.price, item.currency)}
                        </div>
                      </span>

                      <b style={{ fontSize: 12 }}>
                        {moneyText(item.line_total, item.currency)}
                      </b>
                    </label>
                  );
                })}
              </div>
            </div>
          )}

          {billMode === "amount" && (
            <input
              value={billAmount}
              onChange={(e) => setBillAmount(e.target.value)}
              placeholder="Ödenecek tutar. Örn: 250"
              inputMode="decimal"
            style={{
  width: "100%",
  border: "1px solid #cbd5e1",
  borderRadius: 16,
  padding: "13px 14px",
  fontWeight: 850,
  marginBottom: 12,
  outline: "none",
  background: "#ffffff",
  color: "#0f172a",
  WebkitTextFillColor: "#0f172a",
  caretColor: "#f97316",
  opacity: 1,
  fontSize: 15,
}}
            />
          )}

       {billMode ===
  "people" && (
  <div
    style={{
      marginBottom: 12,
    }}
  >
    <input
      value={
        billPeopleCount
      }

      onChange={(
        event
      ) =>
        setBillPeopleCount(
          event.target.value.replace(
            /[^0-9]/g,
            ""
          )
        )
      }

      placeholder="Kişi sayısı. Örn: 4"

      inputMode="numeric"

      style={{
        width: "100%",

        boxSizing:
          "border-box",

        border:
          "1px solid #cbd5e1",

        borderRadius: 16,

        padding:
          "13px 14px",

        fontWeight: 850,

        outline: "none",

        background:
          "#ffffff",

        color:
          "#0f172a",

        WebkitTextFillColor:
          "#0f172a",

        caretColor:
          "#f97316",

        opacity: 1,

        fontSize: 15,
      }}
    />

    {Number(
      billPeopleCount ||
        0
    ) > 0 && (
      <div
        style={{
          marginTop: 8,

          padding:
            "12px 14px",

          borderRadius: 16,

          border:
            "1px solid #bfdbfe",

          background:
            "#eff6ff",

          color:
            "#0f172a",

          display: "flex",

          justifyContent:
            "space-between",

          alignItems:
            "center",

          gap: 12,
        }}
      >
        <div>
          <div
            style={{
              color:
                "#475569",

              fontSize: 11,

              fontWeight: 800,
            }}
          >
            Kişi başı ödenecek
          </div>

          <div
            style={{
              marginTop: 3,

              color:
                "#1d4ed8",

              fontSize: 19,

              fontWeight: 950,
            }}
          >
            {moneyText(
              billNumber(
                tableBillData
                  .remaining_amount
              ) /
                Number(
                  billPeopleCount
                ),

              tableBillData
                .currency
            )}
          </div>
        </div>

        <div
          style={{
            color:
              "#334155",

            fontSize: 12,

            fontWeight: 850,

            textAlign:
              "right",
          }}
        >
          {billPeopleCount} kişi

          <br />

          Toplam{" "}

          {moneyText(
            tableBillData
              .remaining_amount,

            tableBillData
              .currency
          )}
        </div>
      </div>
    )}
  </div>
)}

          {menuOptions.bahsis_active && (
            <input
              value={billTipAmount}
              onChange={(e) => setBillTipAmount(e.target.value)}
              placeholder="Bahşiş ekle. Örn: 50"
              inputMode="decimal"
              style={{
                width: "100%",
                border: "1px solid #fed7aa",
                background: "#fff7ed",
                color: "#9a3412",
                borderRadius: 16,
                padding: "13px 14px",
                fontWeight: 850,
                marginBottom: 12,
                outline: "none",
              }}
            />
          )}

          <div
            style={{
              background: "#0f172a",
              color: "#fff",
              borderRadius: 20,
              padding: 14,
              marginBottom: 12,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
            }}
          >
            <div>
              <div style={{ fontSize: 11, opacity: 0.75, fontWeight: 800 }}>
                Talep Edilecek Tutar
              </div>
              <div style={{ fontSize: 20, fontWeight: 950 }}>
                {moneyText(
                  getBillRequestAmount() +
                    Math.max(
                      Number(String(billTipAmount || "0").replace(",", ".") || 0),
                      0
                    ),
                  tableBillData.currency
                )}
              </div>
            </div>

            <button
              type="button"
              disabled={billSubmitting}
              onClick={submitBillPaymentRequest}
              style={{
                border: 0,
                borderRadius: 15,
                padding: "12px 14px",
                background: billSubmitting ? "#94a3b8" : "#22c55e",
                color: "#fff",
                fontWeight: 950,
                cursor: billSubmitting ? "not-allowed" : "pointer",
              }}
            >
              {billSubmitting ? "Gönderiliyor..." : "Talep Oluştur"}
            </button>
          </div>
        </>
      )}

      {!tableBillData && (
        <div
          style={{
            background: "#fff",
            border: "1px dashed #cbd5e1",
            borderRadius: 20,
            padding: 14,
            color: "#334155",
          }}
        >
          <div style={{ fontWeight: 950, fontSize: 14, color: "#0f172a" }}>
            ✅ Canlı masa hesabı
          </div>
          <div
            style={{
              marginTop: 6,
              fontSize: 12,
              lineHeight: "18px",
              fontWeight: 700,
              color: "#64748b",
            }}
          >
            Masa numarasını yazıp hesabı getirin. Siparişler, ödenen tutar ve kalan hesap burada canlı görünür.
          </div>
        </div>
      )}
    </div>
  </div>
)}




             {/* ===== PROFESYONEL SEPET DRAWER ===== */}
{menuOptions.siparis_active && showCart && (
  <div
    className="cart-backdrop-pro"
    onClick={() => setShowCart(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(15,23,42,.62)",
      backdropFilter: "blur(5px)",
      zIndex: 620,
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      padding: "0 10px"
    }}
  >
    <div
      className="cart-sheet-pro"
      onClick={(e) => e.stopPropagation()}
      style={{
        background:
          "linear-gradient(180deg, rgba(255,255,255,.99), rgba(248,250,252,.99))",
        width: "100%",
      maxWidth: 460,
borderTopLeftRadius: 26,
borderTopRightRadius: 26,
padding: "12px 12px 16px",
maxHeight: "78vh",
        overflowY: "auto",
        boxShadow: "0 -24px 70px rgba(15,23,42,.38)",
        border: "1px solid rgba(255,255,255,.85)"
      }}
    >
      <div
        style={{
          width: 54,
          height: 5,
          borderRadius: 999,
          background: "#cbd5e1",
          margin: "0 auto 16px"
        }}
      />

      <div
        style={{
          background: `linear-gradient(135deg, ${themeStyle.dark}, ${themeStyle.primary})`,
          borderRadius: 20,
          padding: "12px 13px",
          color: "#fff",
          marginBottom: 12,
          boxShadow: "0 14px 34px rgba(15,23,42,.22)",
          position: "relative",
          overflow: "hidden"
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 150,
            height: 150,
            borderRadius: "50%",
            background: "rgba(255,255,255,.12)",
            right: -50,
            top: -60
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "relative",
            zIndex: 2
          }}
        >
          <div>
            <div
              style={{
                fontSize: 11,
                fontWeight: 800,
                opacity: .82,
                letterSpacing: .7,
                textTransform: "uppercase"
              }}
            >
              Sipariş Özeti
            </div>

            <h2
              style={{
                margin: "4px 0 0",
                fontSize: 20,
                fontWeight: 950
              }}
            >
              🛒 {t("cart", lang)}
            </h2>
          </div>

          <button
            onClick={() => setShowCart(false)}
            style={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,.35)",
              background: "rgba(255,255,255,.16)",
              color: "#fff",
              fontSize: 18,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            ✕
          </button>
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 14,
            position: "relative",
            zIndex: 2
          }}
        >
          <div
            style={{
              flex: 1,
              background: "rgba(255,255,255,.16)",
              border: "1px solid rgba(255,255,255,.20)",
              borderRadius: 14,
              padding: "7px 9px"
            }}
          >
            <div style={{ fontSize: 12, opacity: .78, fontWeight: 700 }}>
              Ürün
            </div>
            <div style={{ fontSize: 15, fontWeight: 950 }}>
              {cart.reduce((s, i) => s + i.quantity, 0)}
            </div>
          </div>

          <div
            style={{
              flex: 1,
              background: "rgba(255,255,255,.16)",
              border: "1px solid rgba(255,255,255,.20)",
              borderRadius: 18,
              padding: "10px 12px"
            }}
          >
            <div style={{ fontSize: 12, opacity: .78, fontWeight: 700 }}>
              {t("total", lang)}
            </div>
            <div style={{ fontSize: 18, fontWeight: 950 }}>
              {cartTotal.toFixed(2)} {cart[0]?.currency || "TL"}
            </div>
          </div>
        </div>
      </div>

      {cart.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "34px 18px",
            background: "#fff",
            borderRadius: 17,
            border: "1px dashed #cbd5e1"
          }}
        >
          <div style={{ fontSize: 44, marginBottom: 10 }}>🛒</div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 950,
              color: "#0b1d2d",
              marginBottom: 6
            }}
          >
            {t("emptyCart", lang)}
          </div>
          <div
            style={{
              fontSize: 11,
              color: "#64748b",
              fontWeight: 650
            }}
          >
            Beğendiğiniz ürünleri sepete ekleyerek sipariş oluşturabilirsiniz.
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              display: "grid",
              gap: 10,
              marginBottom: 16
            }}
          >
            {cart.map((item, index) => (
  <div
    key={item.id}
                className="cart-item-pro"
                style={{
                  animationDelay: `${index * 45}ms`,
                  background: "#fff",
                  borderRadius: 20,
                  padding: 12,
                  border: "1px solid #edf0f4",
                  boxShadow: "0 8px 22px rgba(15,23,42,.08)",
                  display: "grid",
                  gridTemplateColumns: "1fr auto",
                  gap: 10,
                  alignItems: "center"
                }}
              >
                <div style={{ minWidth: 0 }}>
                  <strong
                    style={{
                      display: "block",
                      fontSize: 12,
                      color: "#0b1d2d",
                      lineHeight: "19px",
                      fontWeight: 950
                    }}
                  >
                    {item.title}
                  </strong>

                  <small
                    style={{
                      display: "block",
                      marginTop: 4,
                      color: "#64748b",
                      fontWeight: 700
                    }}
                  >
                    {item.price} {item.currency} × {item.quantity}
                  </small>

                  <button
                    onClick={() => removeFromCart(item.id)}
                    style={{
                      marginTop: 8,
                      border: "none",
                      background: "#fee2e2",
                      color: "#b91c1c",
                      borderRadius: 999,
                      padding: "5px 10px",
                      fontSize: 12,
                      fontWeight: 850,
                      cursor: "pointer"
                    }}
                  >
                    Sil
                  </button>
                </div>

<div
  className="menu-products-open"
  style={{
    padding: 12,
    display: "flex",
    flexDirection: "column",
    gap: 10
  }}
>
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 950,
                      color: themeStyle.primary,
                      whiteSpace: "nowrap"
                    }}
                  >
                    {(item.price * item.quantity).toFixed(2)} {item.currency}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      background: "#f1f5f9",
                      borderRadius: 999,
                      padding: 5
                    }}
                  >
                    <button
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      style={{
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontWeight: 950,
                        color: "#0b1d2d"
                      }}
                    >
                      -
                    </button>

                    <span
                      style={{
                        minWidth: 22,
                        textAlign: "center",
                        fontWeight: 950,
                        color: "#0b1d2d"
                      }}
                    >
                      {item.quantity}
                    </span>

                    <button
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      style={{
                        background: themeStyle.primary,
                        border: "none",
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        cursor: "pointer",
                        fontWeight: 950,
                        color: themeStyle.dark
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

                  <div
            style={{
              background: "#f8fafc",
              borderRadius: 24,
              padding: 14,
              border: "1px solid #e2e8f0",
              boxShadow: "0 10px 26px rgba(15,23,42,0.10)",
              color: "#0b1d2d"
            }}
          >
            <TextField
              label={t("customerName", lang)}
              fullWidth
              margin="normal"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
            />

          

<TextField
  label={
    qrTableNo
      ? `Masa / Oda · ${qrSalonName || "QR"}`
      : t("tableNo", lang)
  }

  fullWidth
  margin="normal"

  value={
    qrTableNo ||
    tableNo
  }

  onChange={(event) => {
    if (!qrTableNo) {
      setTableNo(
        event.target.value
      );
    }
  }}

  type="text"

  InputProps={{
    readOnly: Boolean(
      qrTableNo
    ),
  }}
/>
            <TextField
              label={t("orderNote", lang)}
              fullWidth
              margin="normal"
              value={orderNote}
              onChange={(e) => setOrderNote(e.target.value)}
              multiline
              rows={3}
            />

            <div
              style={{
                marginTop: 14,
                padding: "14px 0",
                borderTop: "1px solid #e5e7eb",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <span
                style={{
                  fontSize: 15,
                  fontWeight: 850,
                  color: "#64748b"
                }}
              >
                {t("total", lang)}
              </span>

              <span
                style={{
                  fontSize: 22,
                  fontWeight: 950,
                  color: "#0b1d2d"
                }}
              >
                {cartTotal.toFixed(2)} {cart[0]?.currency || "TL"}
              </span>
            </div>

            <button
              onClick={submitOrder}
              style={{
                marginTop: 8,
                width: "100%",
                border: "none",
                borderRadius: 999,
                padding: "12px 15px",
                background: `linear-gradient(135deg, ${themeStyle.primary}, #ff7a00)`,
                color: themeStyle.dark,
                fontWeight: 950,
                fontSize: 14,

                cursor: "pointer",
                boxShadow: "0 12px 28px rgba(255,138,0,.28)"
              }}
            >
              {t("orderNow", lang)}
            </button>
          </div>
               </>
      )}
    </div>
  </div>
)}
    </div>
  );
}
